(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7156],{

/***/ 72742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowRight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.192 9L5.6 5 1.192 1",
    stroke: "#383838",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight);

/***/ }),

/***/ 20771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLorryOutline(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#lorry-outline_svg__clip0_1_22789)",
    stroke: "#2355FC",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.331 11.997V4a1.333 1.333 0 00-1.333-1.333H2.666a1.333 1.333 0 00-1.333 1.333v7.332a.667.667 0 00.667.666h1.333M9.998 11.997h-4M12.664 11.997h1.333a.666.666 0 00.666-.666V8.898a.667.667 0 00-.146-.416l-2.32-2.9a.666.666 0 00-.52-.25H9.331"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.33 13.33a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666zM4.666 13.33a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666z"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "lorry-outline_svg__clip0_1_22789"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h15.996v15.996H0z"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLorryOutline);

/***/ }),

/***/ 16298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LineDivider; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
;// CONCATENATED MODULE: ../core-ui/dist/components/LineDivider/LineDivider.styles.js



const StyledLineDivider = styled_components_browser_esm/* default.span */.ZP.span `
    display: inline-block;
    width: ${({ width }) => (width ? width : "100%")};
    margin: ${({ margin }) => (margin ? margin : "1px 0")};
    border-bottom-width: ${({ borderWidth }) => borderWidth ? `${borderWidth}px` : "1px"};
    border-bottom-color: ${({ color }) => (color ? color : colors/* default.GREY_300 */.Z.GREY_300)};
    border-bottom-style: ${({ styleType }) => styleType ? styleType : "dashed"};
`;
const StyledLinearLineDivider = styled_components_browser_esm/* default.div */.ZP.div `
    height: ${({ linearGradientHeight }) => `${linearGradientHeight ? linearGradientHeight + "px" : "2px"}`};
    background: ${({ color, linearGradientDirect }) => linearGradientDirect === "toLeft"
    ? `linear-gradient(to left, #fff, ${color ? color : colors/* default.GREY_200 */.Z.GREY_200})`
    : linearGradientDirect === "toRight"
        ? `linear-gradient(to left, ${color ? color : colors/* default.GREY_200 */.Z.GREY_200}, #fff)`
        : `linear-gradient(to left, #fff, ${color ? color : colors/* default.GREY_200 */.Z.GREY_200}, #fff)`};
    width: ${({ width }) => (width ? width : "100%")};
    margin: ${({ margin }) => (margin ? margin : "1px 0")};
`;


//# sourceMappingURL=LineDivider.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/LineDivider/LineDivider.js




const LineDivider = (0,react.forwardRef)((props, ref) => {
    return props.linearGradient ? ((0,jsx_runtime.jsx)(StyledLinearLineDivider, Object.assign({}, props))) : ((0,jsx_runtime.jsx)(StyledLineDivider, Object.assign({}, props)));
});


//# sourceMappingURL=LineDivider.js.map


/***/ }),

/***/ 25354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _LineDivider_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _LineDivider_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16298);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 60894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Radio_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Radio_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84789);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 68732:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/[...params]",
      function () {
        return __webpack_require__(78801);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _vahak_core_dist_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72742);
/* harmony import */ var _animate_HomepageV2Animate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16440);
/* harmony import */ var _section_card_HomepageV2SectionCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63968);
/* harmony import */ var _web_v2_section_header_WebV2SectionHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11250);
/* harmony import */ var _WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10599);
/* harmony import */ var _WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var WebV2FaqSection = function(param) {
    var eyebrow = param.eyebrow, title = param.title, items = param.items, titleClassName = param.titleClassName, containerClassName = param.containerClassName, _align = param.align, align = _align === void 0 ? "center" : _align;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(-1), openIndex = ref[0], setOpenIndex = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_section_card_HomepageV2SectionCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        variant: "white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container), containerClassName),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_animate_HomepageV2Animate__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: "fade-up",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_web_v2_section_header_WebV2SectionHeader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        eyebrow: eyebrow,
                        title: title,
                        align: align,
                        className: (_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().sectionHeader),
                        titleClassName: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().sectionTitle), titleClassName)
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().list),
                    children: items.map(function(item, index) {
                        var isOpen = openIndex === index;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_animate_HomepageV2Animate__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            variant: "fade-up",
                            delay: index * 70,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().item), isOpen && (_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().itemOpen)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        type: "button",
                                        className: (_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().questionBtn),
                                        "aria-expanded": isOpen,
                                        onClick: function() {
                                            return setOpenIndex(isOpen ? -1 : index);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: item.question
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().chevron), isOpen && (_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().chevronOpen)),
                                                "aria-hidden": true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().answerWrap), isOpen && (_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().answerWrapOpen)),
                                        "aria-hidden": !isOpen,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().answerInner),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: (_WebV2FaqSection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().answer),
                                                children: item.answer
                                            })
                                        })
                                    })
                                ]
                            })
                        }, item.question);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebV2FaqSection);


/***/ }),

/***/ 11250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _WebV2SectionHeader_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68177);
/* harmony import */ var _WebV2SectionHeader_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_WebV2SectionHeader_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var WebV2SectionHeader = function(param) {
    var eyebrow = param.eyebrow, title = param.title, description = param.description, className = param.className, titleClassName = param.titleClassName, descriptionClassName = param.descriptionClassName, _align = param.align, align = _align === void 0 ? "center" : _align;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_WebV2SectionHeader_module_scss__WEBPACK_IMPORTED_MODULE_3___default().header), (_WebV2SectionHeader_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[align], className),
        children: [
            eyebrow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_WebV2SectionHeader_module_scss__WEBPACK_IMPORTED_MODULE_3___default().eyebrow),
                children: eyebrow
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_WebV2SectionHeader_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title), titleClassName),
                children: title
            }),
            description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_WebV2SectionHeader_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description), descriptionClassName),
                children: description
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebV2SectionHeader);


/***/ }),

/***/ 81008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bj": function() { return /* binding */ MARKETPLACE_V3_MOBILE_CAROUSEL; },
/* harmony export */   "EO": function() { return /* binding */ buildMarketplaceV3SearchUrl; },
/* harmony export */   "FE": function() { return /* binding */ getMarketplaceV3UrlKey; },
/* harmony export */   "Fz": function() { return /* binding */ MARKETPLACE_V3_LOADS_SECTION_ID; },
/* harmony export */   "f6": function() { return /* binding */ MARKETPLACE_V3_LOADS_GRID; },
/* harmony export */   "iV": function() { return /* binding */ keepsMarketingLayout; },
/* harmony export */   "jU": function() { return /* binding */ MARKETPLACE_V3_ASSETS; },
/* harmony export */   "nH": function() { return /* reexport safe */ _marketplace_new_marketplacePageHelpers__WEBPACK_IMPORTED_MODULE_2__.nH; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87394);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94204);
/* harmony import */ var _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12098);
/* harmony import */ var _marketplace_new_marketplacePageHelpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94280);



var MARKETPLACE_V3_ASSETS = {
    benefitCheckIcon: "/homepage-v2/icons/benefit-check.svg",
    noLoadAvailableImage: "/homepage-v2/no-load-available-banner.png"
};
var MARKETPLACE_V3_MOBILE_CAROUSEL = {
    cssMode: false,
    slidesPerView: 1,
    spaceBetween: 16,
    navigation: false,
    pagination: true
};
var MARKETPLACE_V3_LOADS_GRID = {
    desktopPageSize: 4,
    mobilePageSize: 3,
    viewMoreClicksBeforeLogin: 2
};
var MARKETPLACE_V3_LOADS_SECTION_ID = "marketplace-v3-loads";
/** Marketplace v3 marketing shell — load browse and lorry booking landing pages. */ function keepsMarketingLayout(pathname) {
    return pathname.startsWith("/marketplace/load") || pathname.startsWith("/marketplace/lorry");
}
var toSlug = function(label) {
    return label === null || label === void 0 ? void 0 : label.replace(/ /g, "-").toLowerCase();
};
/** Mirrors SSR parsing in `pages/marketplace/[...params].tsx`. */ 
function buildMarketplaceV3SearchUrl(param) {
    var srcState = param.srcState, _destStates = param.destStates, destStates = _destStates === void 0 ? [] : _destStates, _lorryTypeIds = param.lorryTypeIds, lorryTypeIds = _lorryTypeIds === void 0 ? [] : _lorryTypeIds;
    var ref;
    var srcSlug = toSlug(srcState === null || srcState === void 0 ? void 0 : srcState.label);
    var destSlug = toSlug((ref = destStates.filter(function(state) {
        return state.id !== -1;
    })[0]) === null || ref === void 0 ? void 0 : ref.label);
    var path = _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.marketplace.getUrl */ .Z.marketplace.getUrl(_vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .MarketPlaceType.LOAD */ .CY3.LOAD, srcSlug, destSlug);
    var searchParams = new URLSearchParams();
    if (lorryTypeIds.length) {
        (0,_vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .getAllowedVehicleList */ .UE5)("lorry").filter(function(lorryType) {
            return lorryTypeIds.includes(lorryType.id);
        }).forEach(function(lorryType) {
            return searchParams.append("l", lorryType.label.toLowerCase());
        });
    }
    var queryString = searchParams.toString();
    return queryString ? "".concat(path, "?").concat(queryString) : path;
}
/** Modal/query params that must not trigger marketplace URL re-hydration. */ var MARKETPLACE_V3_TRANSIENT_QUERY_PARAMS = [
    "lorry-posting-form",
    "load-posting-form"
];
/**
 * Marketplace path + filter query only. Strips hash and posting-form modal params so
 * opening load/lorry posting does not re-run URL hydration (which would wipe the modal query).
 */ function getMarketplaceV3UrlKey(asPath) {
    var pathWithoutHash = asPath.split("#")[0];
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(pathWithoutHash.split("?"), 2), pathname = ref[0], tmp = ref[1], query = tmp === void 0 ? "" : tmp;
    var searchParams = new URLSearchParams(query);
    MARKETPLACE_V3_TRANSIENT_QUERY_PARAMS.forEach(function(param) {
        return searchParams.delete(param);
    });
    var queryString = searchParams.toString();
    return queryString ? "".concat(pathname, "?").concat(queryString) : pathname;
}


/***/ }),

/***/ 78801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _params_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var constants = __webpack_require__(94204);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../core/dist/_services/city-search.service.js
var city_search_service = __webpack_require__(20803);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ./components/common/page-meta-tags/PageMetaTags.tsx
var PageMetaTags = __webpack_require__(96696);
// EXTERNAL MODULE: ./components/homepage-v2/app-download-banner/AppDownloadBannerV2.tsx
var AppDownloadBannerV2 = __webpack_require__(99837);
// EXTERNAL MODULE: ./components/homepage-v2/analytics/useWebV2Tracker.ts + 1 modules
var useWebV2Tracker = __webpack_require__(61782);
// EXTERNAL MODULE: ./components/marketplace-new/marketplacePageHelpers.ts
var marketplacePageHelpers = __webpack_require__(94280);
// EXTERNAL MODULE: ./MarketplaceContextProvider.tsx
var MarketplaceContextProvider = __webpack_require__(43103);
// EXTERNAL MODULE: ./services/usePlaceSearchQuery.ts
var usePlaceSearchQuery = __webpack_require__(16038);
// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/marketplaceV3.constants.ts
var marketplaceV3_constants = __webpack_require__(81008);
// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/MarketplaceV3.module.scss
var MarketplaceV3_module = __webpack_require__(83915);
var MarketplaceV3_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceV3_module);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ./components/homepage-v2/animate/HomepageV2Animate.tsx
var HomepageV2Animate = __webpack_require__(16440);
// EXTERNAL MODULE: ./components/homepage-v2/analytics/homepageV2WebAnalytics.ts
var homepageV2WebAnalytics = __webpack_require__(7339);
// EXTERNAL MODULE: ./components/homepage-v2/analytics/trackLoadQuoteFormAnalytics.ts
var trackLoadQuoteFormAnalytics = __webpack_require__(78582);
// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/useMarketplaceV3Translation.ts
var useMarketplaceV3Translation = __webpack_require__(20065);
// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3HeroSection.module.scss
var MarketplaceV3HeroSection_module = __webpack_require__(97776);
var MarketplaceV3HeroSection_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceV3HeroSection_module);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/standard-icons/location-pin-outlined.svg
var location_pin_outlined = __webpack_require__(90831);
// EXTERNAL MODULE: ../core/dist/standard-icons/location-arrow.svg
var location_arrow = __webpack_require__(38188);
// EXTERNAL MODULE: ../core/dist/icons/arrow-right-white.svg
var arrow_right_white = __webpack_require__(89905);
// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/MarketplaceLoadFilterCard.module.scss
var MarketplaceLoadFilterCard_module = __webpack_require__(15841);
var MarketplaceLoadFilterCard_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceLoadFilterCard_module);
// EXTERNAL MODULE: ../core-ui/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(29216);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/react-select.esm.js + 9 modules
var react_select_esm = __webpack_require__(74800);
// EXTERNAL MODULE: ../core-ui/dist/components/CompactSelect/CompactSelect.styles.js
var CompactSelect_styles = __webpack_require__(18831);
// EXTERNAL MODULE: ../core-ui/dist/components/CompactSelect/RCompactSelectDerived.js
var RCompactSelectDerived = __webpack_require__(85666);
// EXTERNAL MODULE: ../core-ui/dist/components/Select/RSelectDerived.js + 1 modules
var RSelectDerived = __webpack_require__(11350);
;// CONCATENATED MODULE: ../core-ui/dist/components/CompactSelect/CompactSelect.js








const CompactSelect = react.forwardRef((props, ref) => {
    const { id, name, option, noOptionText, noOptionHandler, labelFormatter, value = null, menuPlacement = "auto", menuPosition = "absolute", components } = props, restCommonProps = (0,_tslib/* __rest */._)(props, ["id", "name", "option", "noOptionText", "noOptionHandler", "labelFormatter", "value", "menuPlacement", "menuPosition", "components"]);
    const commonProps = Object.assign({ name, id: `${id}__container`, inputId: `${id}__input`, instanceId: id, ref,
        value, options: option, menuPlacement,
        menuPosition, components: Object.assign({ SelectContainer: RSelectDerived/* ContainerComponent */.e$, DropdownIndicator: RSelectDerived/* DropdownIndicatorComponent */.fz, Control: RCompactSelectDerived/* CompactControlComponent */._, SingleValue: RSelectDerived/* SingleValueComponent */.G$, NoOptionsMessage: RSelectDerived/* NoOptionsMessageComponent */.c1, Option: RSelectDerived/* OptionComponent */.x8, Input: RSelectDerived/* InputComponent */.am, IndicatorSeparator: null, ValueContainer: RSelectDerived/* ValueComponent */.u$, Placeholder: RSelectDerived/* PlaceholderComponent */.WB, ClearIndicator: RSelectDerived/* ClearIconComponent */.OD }, components), noOptionsMessage: noOptionHandler !== null && noOptionHandler !== void 0 ? noOptionHandler : (() => noOptionText !== null && noOptionText !== void 0 ? noOptionText : "No Option"), formatOptionLabel: labelFormatter }, restCommonProps);
    return ((0,jsx_runtime.jsx)(CompactSelect_styles/* StyledCompactSelectWrapper */.U, { children: (0,jsx_runtime.jsx)(react_select_esm["default"], Object.assign({}, commonProps)) }));
});


//# sourceMappingURL=CompactSelect.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/CompactSelect/index.js




//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/index-641ee5b8.esm.js + 3 modules
var index_641ee5b8_esm = __webpack_require__(99438);
// EXTERNAL MODULE: ./components/homepage-v2/load-quote/quoteFormSelectParts.tsx
var quoteFormSelectParts = __webpack_require__(83165);
;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/filter-fields/marketplaceQuoteFormFieldParts.tsx








var filterMarketplaceStateOption = quoteFormSelectParts/* filterOptionByLabel */.pM;
function createQuoteFormStateOption(Styles) {
    return function(props) {
        var data = props.data, isFocused = props.isFocused, isSelected = props.isSelected, selectProps = props.selectProps;
        var inputValue = String(selectProps.inputValue || "");
        var isActive = isFocused || isSelected;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_641ee5b8_esm.c.Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            className: classnames_default()(Styles.locationOption, isActive && Styles.locationOptionActive),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: Styles.locationOptionText,
                children: (0,quoteFormSelectParts/* renderHighlightedText */.EG)(data.label, inputValue, Styles.locationMatch)
            })
        }));
    };
}
function createQuoteFormNoOptionsMessage(Styles, getMessage) {
    return (0,quoteFormSelectParts/* createQuoteFormNoOptionsMessage */.UY)(Styles, getMessage);
}
function createQuoteFormLocationMenuAlways(Styles) {
    return (0,quoteFormSelectParts/* createQuoteFormLocationMenu */.MP)(Styles, false);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./methods/uiUtil.ts
var uiUtil = __webpack_require__(34695);
;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/filter-fields/marketplaceFilterStateOptions.ts




var MARKETPLACE_STATE_OPTIONS = (0,_to_consumable_array/* default */.Z)(constants/* STATE_LIST */.t44).sort(function(a, b) {
    return a.name.localeCompare(b.name);
}).map(function(state) {
    return (0,uiUtil/* generateSelectOption */.Ow)(state.name, state.id, state.id);
});
function findMarketplaceStateOptionFromUrlParam(param) {
    if (!(param === null || param === void 0 ? void 0 : param.trim())) {
        return undefined;
    }
    return MARKETPLACE_STATE_OPTIONS.find(function(state) {
        return (0,methods/* compareString */.rR)(state.label, param.trim());
    });
}
var MARKETPLACE_ANY_DESTINATION_ID = -1;
var MARKETPLACE_ANY_DESTINATION_OPTION = (0,uiUtil/* generateSelectOption */.Ow)("Any Destination", MARKETPLACE_ANY_DESTINATION_ID, MARKETPLACE_ANY_DESTINATION_ID);
var MARKETPLACE_DESTINATION_STATE_OPTIONS = [
    MARKETPLACE_ANY_DESTINATION_OPTION
].concat((0,_to_consumable_array/* default */.Z)(MARKETPLACE_STATE_OPTIONS));
/** @deprecated Use MARKETPLACE_STATE_OPTIONS */ var STATE_LIST_OPTION = (/* unused pure expression or super */ null && (MARKETPLACE_STATE_OPTIONS));
/** @deprecated Use MARKETPLACE_DESTINATION_STATE_OPTIONS */ var STATE_LIST_OPTION_WITH_ANY_DESTINATION = (/* unused pure expression or super */ null && (MARKETPLACE_DESTINATION_STATE_OPTIONS));
/** @deprecated Use MARKETPLACE_ANY_DESTINATION_ID */ var ANY_DESTINATION_ID = (/* unused pure expression or super */ null && (MARKETPLACE_ANY_DESTINATION_ID));
function isAnyDestinationSelected(value) {
    return !(value === null || value === void 0 ? void 0 : value.length) || value.every(function(item) {
        return item.id === MARKETPLACE_ANY_DESTINATION_ID;
    });
}
function resolveMultiDestinationChange(_previous, selected) {
    var pickedAny = selected.some(function(item) {
        return item.id === MARKETPLACE_ANY_DESTINATION_ID;
    });
    if (pickedAny) {
        return [];
    }
    return selected.filter(function(item) {
        return item.id !== MARKETPLACE_ANY_DESTINATION_ID;
    });
}
function getMultiSelectDisplayLabel(value) {
    var selectedStates = (value !== null && value !== void 0 ? value : []).filter(function(item) {
        return item.id !== MARKETPLACE_ANY_DESTINATION_ID;
    });
    if (!selectedStates.length) {
        return "";
    }
    return selectedStates.map(function(item) {
        return item.label;
    }).join(", ");
}

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../core-ui/dist/components/Checkbox/index.js + 2 modules
var Checkbox = __webpack_require__(94072);
// EXTERNAL MODULE: ../core-ui/dist/components/LineDivider/index.js
var LineDivider = __webpack_require__(25354);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ../core-ui/dist/components/Radio/index.js
var Radio = __webpack_require__(60894);
// EXTERNAL MODULE: ./components/quick-action-popup/QuickActionPopup.tsx
var QuickActionPopup = __webpack_require__(37372);
// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/filter-fields/MarketplaceFilterMobileSheet.module.scss
var MarketplaceFilterMobileSheet_module = __webpack_require__(40601);
var MarketplaceFilterMobileSheet_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceFilterMobileSheet_module);
;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/filter-fields/MarketplaceFilterMobileSheet.tsx











var MarketplaceFilterMobileSheet = function(param) {
    var title = param.title, options = param.options, value = param.value, _isMulti = param.isMulti, isMulti = _isMulti === void 0 ? false : _isMulti, onChange = param.onChange, onClose = param.onClose;
    var ref = (0,react.useState)(value), localValues = ref[0], setLocalValues = ref[1];
    var ref1 = (0,react.useState)(false), isMounted = ref1[0], setIsMounted = ref1[1];
    var isLocalAny = isAnyDestinationSelected(localValues);
    (0,react.useEffect)(function() {
        setIsMounted(true);
    }, []);
    (0,react.useEffect)(function() {
        setLocalValues(value);
    }, [
        value
    ]);
    var selectCheckBox = function(option) {
        if (option.id === MARKETPLACE_ANY_DESTINATION_OPTION.id) {
            setLocalValues([]);
            return;
        }
        setLocalValues(function(current) {
            return (0,_to_consumable_array/* default */.Z)(current.filter(function(item) {
                return item.id !== MARKETPLACE_ANY_DESTINATION_OPTION.id;
            })).concat([
                option
            ]);
        });
    };
    var deselectCheckBox = function(option) {
        setLocalValues(function(current) {
            return current.filter(function(item) {
                return item.id !== option.id;
            });
        });
    };
    var onApply = function() {
        onChange(localValues);
        onClose();
    };
    if (!isMounted) {
        return null;
    }
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(QuickActionPopup/* default */.Z, {
        popupProps: {
            fullScreenSheet: true
        },
        modalProps: {
            modalBodyHeight: "60vh"
        },
        modalSize: "fit",
        isOpen: true,
        titleText: title,
        onToggle: onClose,
        ctaAction: onApply,
        ctaText: "Apply",
        ctaPlacement: "footer",
        commonCtaProps: {
            isRounded: true,
            blockBtn: true
        },
        secondaryCtaText: "Clear selection",
        secondaryCtaProps: {
            onClick: function() {
                onChange([]);
                onClose();
            },
            disabled: localValues.length === 0 && isLocalAny
        },
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (MarketplaceFilterMobileSheet_module_default()).sheet,
            children: isMulti ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* VerticalFlex */.vs, {
                gap: 12,
                children: options.map(function(option, index, arr) {
                    var isAnyOption = option.id === MARKETPLACE_ANY_DESTINATION_OPTION.id;
                    var isChecked = isAnyOption ? isLocalAny : Boolean(localValues.find(function(item) {
                        return item.id === option.id;
                    }));
                    var handleToggle = function() {
                        if (isChecked) {
                            deselectCheckBox(option);
                        } else {
                            selectCheckBox(option);
                        }
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: (MarketplaceFilterMobileSheet_module_default()).rowButton,
                                onClick: handleToggle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    size: "md",
                                    id: String(option.id),
                                    label: option.label,
                                    name: String(option.id),
                                    onChange: handleToggle,
                                    value: isChecked,
                                    checkboxWrapperClass: (MarketplaceFilterMobileSheet_module_default()).checkboxRow,
                                    checkBoxLabelClass: (MarketplaceFilterMobileSheet_module_default()).checkboxLabel
                                })
                            }),
                            index < arr.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LineDivider/* default */.Z, {
                                styleType: "solid",
                                width: "100%"
                            }) : null
                        ]
                    }, option.id);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* VerticalFlex */.vs, {
                gap: 0,
                children: options.map(function(option, index, arr) {
                    var ref;
                    var isChecked = Boolean(value.find(function(item) {
                        return item.id === option.id;
                    }));
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MarketplaceFilterMobileSheet_module_default()).radioRow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                    label: option.label,
                                    name: option.label,
                                    id: option.label,
                                    onChange: function() {
                                        onChange([
                                            option
                                        ]);
                                        onClose();
                                    },
                                    value: String(((ref = value[0]) === null || ref === void 0 ? void 0 : ref.value) || ""),
                                    checked: isChecked,
                                    diskPosition: "end"
                                })
                            }),
                            index < arr.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LineDivider/* default */.Z, {
                                styleType: "solid",
                                width: "100%"
                            }) : null
                        ]
                    }, option.id);
                })
            })
        })
    }), document.body);
};
/* harmony default export */ var filter_fields_MarketplaceFilterMobileSheet = (MarketplaceFilterMobileSheet);

;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/filter-fields/MarketplaceFilterStateSingleField.tsx










var MarketplaceFilterStateSingleField = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var id = param.id, placeholder = param.placeholder, icon = param.icon, value = param.value, mobileTitle = param.mobileTitle, onChange = param.onChange;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var _$ref = (0,react.useState)(false), mobileOpen = _$ref[0], setMobileOpen = _$ref[1];
    var selectRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            focus: function() {
                var _$ref, _$ref1;
                if (isMobileScreen) {
                    setMobileOpen(true);
                    return;
                }
                (_$ref = selectRef.current) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.focus) === null || _$ref1 === void 0 ? void 0 : _$ref1.call(_$ref);
            }
        };
    });
    var handleChange = function(option) {
        var selected = option;
        onChange(selected !== null && selected !== void 0 ? selected : undefined);
    };
    var components = (0,react.useMemo)(function() {
        return {
            DropdownIndicator: function() {
                return null;
            },
            Control: (0,quoteFormSelectParts/* createQuoteFormLocationControl */.aG)((MarketplaceLoadFilterCard_module_default()), icon),
            Input: (0,quoteFormSelectParts/* createQuoteFormLocationInput */.iV)(),
            Placeholder: (0,quoteFormSelectParts/* createQuoteFormLocationPlaceholder */.Mf)((MarketplaceLoadFilterCard_module_default())),
            SingleValue: (0,quoteFormSelectParts/* createQuoteFormLocationSingleValue */.mL)((MarketplaceLoadFilterCard_module_default())),
            Menu: createQuoteFormLocationMenuAlways((MarketplaceLoadFilterCard_module_default())),
            Option: createQuoteFormStateOption((MarketplaceLoadFilterCard_module_default())),
            NoOptionsMessage: createQuoteFormNoOptionsMessage((MarketplaceLoadFilterCard_module_default()), function() {
                return "No matching state";
            }),
            MultiValue: quoteFormSelectParts/* hiddenMultiValue */.n
        };
    }, [
        icon
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((MarketplaceLoadFilterCard_module_default()).fieldWrap, (MarketplaceLoadFilterCard_module_default()).fieldWrapSelect, (MarketplaceLoadFilterCard_module_default()).fieldWrapSearchable),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactSelect, (0,_object_spread/* default */.Z)({
                ref: selectRef,
                id: id,
                name: id,
                option: MARKETPLACE_STATE_OPTIONS,
                value: value !== null && value !== void 0 ? value : null,
                placeholder: placeholder,
                isClearable: !isMobileScreen,
                isSearchable: true,
                openMenuOnClick: true,
                openMenuOnFocus: true,
                filterOption: filterMarketplaceStateOption,
                menuPosition: "absolute",
                onChange: handleChange,
                components: components
            }, isMobileScreen && {
                menuIsOpen: false,
                onMenuOpen: function() {
                    var _$ref, _$ref1;
                    (_$ref = selectRef.current) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.blur) === null || _$ref1 === void 0 ? void 0 : _$ref1.call(_$ref);
                    setMobileOpen(true);
                }
            })),
            mobileOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_fields_MarketplaceFilterMobileSheet, {
                title: mobileTitle,
                options: MARKETPLACE_STATE_OPTIONS,
                value: value ? [
                    value
                ] : [],
                onChange: function(next) {
                    return onChange(next[0]);
                },
                onClose: function() {
                    return setMobileOpen(false);
                }
            }) : null
        ]
    });
});
/* harmony default export */ var filter_fields_MarketplaceFilterStateSingleField = (MarketplaceFilterStateSingleField);

;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/filter-fields/MarketplaceFilterStateMultiField.tsx














var MarketplaceFilterStateMultiField = function(param) {
    var id = param.id, placeholder = param.placeholder, icon = param.icon, _value = param.value, value = _value === void 0 ? [] : _value, mobileTitle = param.mobileTitle, onChange = param.onChange;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var ref = (0,react.useState)(false), mobileOpen = ref[0], setMobileOpen = ref[1];
    var selectRef = (0,react.useRef)(null);
    var selectedValue = value.filter(function(item) {
        return item.id !== MARKETPLACE_ANY_DESTINATION_ID;
    });
    var displayLabel = getMultiSelectDisplayLabel(value);
    var handleChange = function(selected) {
        var selectedArr = Array.isArray(selected) ? selected : selected ? [
            selected
        ] : [];
        onChange(resolveMultiDestinationChange(value, selectedArr));
    };
    var selectComponents = (0,react.useMemo)(function() {
        return {
            DropdownIndicator: function() {
                return null;
            },
            Control: (0,quoteFormSelectParts/* createQuoteFormLocationControl */.aG)((MarketplaceLoadFilterCard_module_default()), icon),
            Input: (0,quoteFormSelectParts/* createQuoteFormLocationInput */.iV)(),
            Placeholder: (0,quoteFormSelectParts/* createQuoteFormLocationPlaceholder */.Mf)((MarketplaceLoadFilterCard_module_default())),
            Menu: createQuoteFormLocationMenuAlways((MarketplaceLoadFilterCard_module_default())),
            Option: function(props) {
                var ref;
                var currentValue = (0,_to_consumable_array/* default */.Z)((ref = props.getValue()) !== null && ref !== void 0 ? ref : []);
                var isAnyOption = props.data.id === MARKETPLACE_ANY_DESTINATION_ID;
                var isChecked = isAnyOption ? isAnyDestinationSelected(currentValue) : props.isSelected;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_641ee5b8_esm.c.Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    isSelected: isChecked,
                    className: classnames_default()((MarketplaceLoadFilterCard_module_default()).locationOption, props.isFocused && (MarketplaceLoadFilterCard_module_default()).locationOptionActive),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MarketplaceLoadFilterCard_module_default()).checkboxOptionRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (MarketplaceLoadFilterCard_module_default()).locationOptionText,
                                children: props.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                id: "marketplace-filter-dest-".concat(props.data.id),
                                name: "marketplace-filter-dest-".concat(props.data.id),
                                label: "",
                                value: isChecked,
                                onChange: function() {
                                    return null;
                                }
                            })
                        ]
                    })
                }));
            },
            ValueContainer: (0,quoteFormSelectParts/* createQuoteFormMultiValueContainer */.pP)((MarketplaceLoadFilterCard_module_default()), displayLabel),
            MultiValue: quoteFormSelectParts/* hiddenMultiValue */.n
        };
    }, [
        displayLabel,
        icon
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((MarketplaceLoadFilterCard_module_default()).fieldWrap, (MarketplaceLoadFilterCard_module_default()).fieldWrapSelect, (MarketplaceLoadFilterCard_module_default()).fieldWrapMulti, (MarketplaceLoadFilterCard_module_default()).fieldWrapSearchable),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactSelect, (0,_object_spread/* default */.Z)({
                ref: selectRef,
                id: id,
                name: id,
                isMulti: true,
                closeMenuOnSelect: true,
                hideSelectedOptions: false,
                option: MARKETPLACE_DESTINATION_STATE_OPTIONS,
                value: selectedValue,
                placeholder: placeholder,
                isClearable: !isMobileScreen && selectedValue.length > 0,
                isSearchable: true,
                openMenuOnClick: true,
                openMenuOnFocus: true,
                filterOption: filterMarketplaceStateOption,
                menuPosition: "absolute",
                onChange: handleChange,
                components: selectComponents,
                styles: {
                    multiValue: function() {
                        return {
                            display: "none"
                        };
                    }
                }
            }, isMobileScreen ? {
                menuIsOpen: false,
                onMenuOpen: function() {
                    var ref, ref1;
                    (ref = selectRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.blur) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
                    setMobileOpen(true);
                }
            } : {})),
            mobileOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_fields_MarketplaceFilterMobileSheet, {
                title: mobileTitle,
                options: MARKETPLACE_DESTINATION_STATE_OPTIONS,
                value: value,
                isMulti: true,
                onChange: function(next) {
                    return onChange(next);
                },
                onClose: function() {
                    return setMobileOpen(false);
                }
            }) : null
        ]
    });
};
/* harmony default export */ var filter_fields_MarketplaceFilterStateMultiField = (MarketplaceFilterStateMultiField);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../core/dist/standard-icons/lorry-outline.svg
var lorry_outline = __webpack_require__(20771);
// EXTERNAL MODULE: ../core/dist/standard-icons/down_arrow.svg
var down_arrow = __webpack_require__(48503);
;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/filter-fields/MarketplaceFilterLorryTypeField.tsx

















var MarketplaceFilterLorryTypeField = function(param) {
    var _id = param.id, id = _id === void 0 ? "marketplace-filter-lorry-type" : _id, placeholder = param.placeholder, _value = param.value, value = _value === void 0 ? [] : _value, mobileTitle = param.mobileTitle, onChange = param.onChange;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var ref = (0,react.useState)(false), mobileOpen = ref[0], setMobileOpen = ref[1];
    var selectRef = (0,react.useRef)(null);
    var baseLorryList = (0,constants/* getAllowedVehicleList */.UE5)("lorry");
    var resolvedLorryList = baseLorryList.length ? baseLorryList : (0,constants/* getAllowedVehicleList */.UE5)("load");
    var lorryOptions = resolvedLorryList.map(function(lorryType) {
        return (0,uiUtil/* generateSelectOption */.Ow)(lorryType.label, lorryType.id, lorryType.id);
    });
    var selectedOptions = lorryOptions.filter(function(option) {
        return value.includes(option.value);
    });
    var displayLabel = selectedOptions.length ? selectedOptions.map(function(option) {
        return option.label;
    }).join(", ") : "";
    var handleChange = function(selected) {
        var selectedArr = Array.isArray(selected) ? selected : [];
        onChange(selectedArr.map(function(option) {
            return option.value;
        }));
    };
    var selectComponents = (0,react.useMemo)(function() {
        return {
            Control: (0,quoteFormSelectParts/* createQuoteFormLorryControl */.jU)((MarketplaceLoadFilterCard_module_default()), /*#__PURE__*/ (0,jsx_runtime.jsx)(lorry_outline/* default */.Z, {
                className: (MarketplaceLoadFilterCard_module_default()).fieldIcon
            })),
            DropdownIndicator: (0,quoteFormSelectParts/* createQuoteFormChevronIndicator */.KP)((MarketplaceLoadFilterCard_module_default()), /*#__PURE__*/ (0,jsx_runtime.jsx)(down_arrow/* default */.Z, {
                "aria-hidden": true
            })),
            Placeholder: (0,quoteFormSelectParts/* createQuoteFormLocationPlaceholder */.Mf)((MarketplaceLoadFilterCard_module_default())),
            Menu: function(_param) /*#__PURE__*/ {
                var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
                    "className"
                ]);
                return (0,jsx_runtime.jsx)(index_641ee5b8_esm.c.Menu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    className: classnames_default()(className, (MarketplaceLoadFilterCard_module_default()).lorryDropdownMenu)
                }));
            },
            Option: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_641ee5b8_esm.c.Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    className: classnames_default()((MarketplaceLoadFilterCard_module_default()).lorryOption, props.isFocused && (MarketplaceLoadFilterCard_module_default()).lorryOptionActive, props.isSelected && (MarketplaceLoadFilterCard_module_default()).lorryOptionSelected),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MarketplaceLoadFilterCard_module_default()).checkboxOptionRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (MarketplaceLoadFilterCard_module_default()).locationOptionText,
                                children: props.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                id: "marketplace-lorry-option-".concat(props.data.value),
                                name: "marketplace-lorry-option-".concat(props.data.value),
                                label: "",
                                value: props.isSelected,
                                onChange: function() {
                                    return null;
                                }
                            })
                        ]
                    })
                }));
            },
            ValueContainer: (0,quoteFormSelectParts/* createQuoteFormMultiValueContainer */.pP)((MarketplaceLoadFilterCard_module_default()), displayLabel),
            MultiValue: quoteFormSelectParts/* hiddenMultiValue */.n
        };
    }, [
        displayLabel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((MarketplaceLoadFilterCard_module_default()).fieldWrap, (MarketplaceLoadFilterCard_module_default()).fieldWrapSelect, (MarketplaceLoadFilterCard_module_default()).fieldWrapMulti),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactSelect, (0,_object_spread/* default */.Z)({
                ref: selectRef,
                id: id,
                name: "lorryType",
                isMulti: true,
                closeMenuOnSelect: true,
                hideSelectedOptions: false,
                option: lorryOptions,
                value: selectedOptions,
                placeholder: placeholder,
                isSearchable: false,
                openMenuOnClick: true,
                menuPosition: "absolute",
                onChange: handleChange,
                components: selectComponents,
                styles: {
                    multiValue: function() {
                        return {
                            display: "none"
                        };
                    }
                }
            }, isMobileScreen && {
                menuIsOpen: false,
                onMenuOpen: function() {
                    var ref, ref1;
                    (ref = selectRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.blur) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
                    setMobileOpen(true);
                }
            })),
            mobileOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_fields_MarketplaceFilterMobileSheet, {
                title: mobileTitle,
                options: lorryOptions,
                value: selectedOptions,
                isMulti: true,
                onChange: function(next) {
                    return onChange(next.map(function(option) {
                        return option.value;
                    }));
                },
                onClose: function() {
                    return setMobileOpen(false);
                }
            }) : null
        ]
    });
};
/* harmony default export */ var filter_fields_MarketplaceFilterLorryTypeField = (MarketplaceFilterLorryTypeField);

;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/MarketplaceLoadFilterCard.tsx










var MarketplaceLoadFilterCard = function(param) {
    var eyebrow = param.eyebrow, fromPlaceholder = param.fromPlaceholder, toPlaceholder = param.toPlaceholder, lorryTypePlaceholder = param.lorryTypePlaceholder, searchLabel = param.searchLabel, clearFiltersLabel = param.clearFiltersLabel, _hasActiveFilters = param.hasActiveFilters, hasActiveFilters = _hasActiveFilters === void 0 ? false : _hasActiveFilters, srcState = param.srcState, _destStates = param.destStates, destStates = _destStates === void 0 ? [] : _destStates, _lorryTypeIds = param.lorryTypeIds, lorryTypeIds = _lorryTypeIds === void 0 ? [] : _lorryTypeIds, _showLorryType = param.showLorryType, showLorryType = _showLorryType === void 0 ? true : _showLorryType, srcFieldRef = param.srcFieldRef, onSrcChange = param.onSrcChange, onDestChange = param.onDestChange, onLorryTypeChange = param.onLorryTypeChange, onSearch = param.onSearch, onClearFilters = param.onClearFilters, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((MarketplaceLoadFilterCard_module_default()).card, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (MarketplaceLoadFilterCard_module_default()).eyebrow,
                children: eyebrow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MarketplaceLoadFilterCard_module_default()).filtersRow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((MarketplaceLoadFilterCard_module_default()).row, (MarketplaceLoadFilterCard_module_default()).rowLocations, (MarketplaceLoadFilterCard_module_default()).routeGroup),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_fields_MarketplaceFilterStateSingleField, {
                                ref: srcFieldRef,
                                id: "marketplace-filter-src",
                                placeholder: fromPlaceholder,
                                mobileTitle: fromPlaceholder,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_pin_outlined/* default */.Z, {
                                    className: (MarketplaceLoadFilterCard_module_default()).fieldIconPin,
                                    "aria-hidden": true
                                }),
                                value: srcState,
                                onChange: onSrcChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_fields_MarketplaceFilterStateMultiField, {
                                id: "marketplace-filter-dest",
                                placeholder: toPlaceholder,
                                mobileTitle: toPlaceholder,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_arrow/* default */.Z, {
                                    className: (MarketplaceLoadFilterCard_module_default()).fieldIcon,
                                    "aria-hidden": true
                                }),
                                value: destStates,
                                onChange: onDestChange
                            })
                        ]
                    }),
                    showLorryType ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MarketplaceLoadFilterCard_module_default()).lorryField,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_fields_MarketplaceFilterLorryTypeField, {
                            placeholder: lorryTypePlaceholder,
                            mobileTitle: lorryTypePlaceholder,
                            value: lorryTypeIds,
                            onChange: onLorryTypeChange
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MarketplaceLoadFilterCard_module_default()).actionsRow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: (MarketplaceLoadFilterCard_module_default()).searchBtn,
                        onClick: onSearch,
                        disabled: !srcState,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: searchLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_white/* default */.Z, {
                                className: (MarketplaceLoadFilterCard_module_default()).searchBtnIcon,
                                "aria-hidden": true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (MarketplaceLoadFilterCard_module_default()).clearBtn,
                        onClick: onClearFilters,
                        disabled: !hasActiveFilters,
                        children: clearFiltersLabel
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var marketplace_v3_MarketplaceLoadFilterCard = (MarketplaceLoadFilterCard);

;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3HeroSection.tsx


















function getHeroTitleLines(titleLines) {
    if (Array.isArray(titleLines)) {
        return titleLines.filter(function(line) {
            return typeof line === "string";
        });
    }
    return [];
}
var MarketplaceV3HeroSection = function(param) {
    var trackEvent = param.trackEvent, eventData = param.eventData, updateUrl = param.updateUrl;
    var ref, ref1;
    var t = (0,useMarketplaceV3Translation/* default */.Z)().t;
    var router = (0,next_router.useRouter)();
    var titleLines = getHeroTitleLines(t("hero.titleLines", {
        returnObjects: true
    }));
    var ref2 = (0,react.useContext)(app_context/* AppContext */.Il), companyId = ref2.companyId, isPhoneVerified = ref2.isPhoneVerified, setShouldPreventLayoutSwitch = ref2.setShouldPreventLayoutSwitch;
    var ref3 = (0,react.useContext)(MarketplaceContextProvider/* MarketplaceContext */.iT), marketplaceConfig = ref3.marketplaceConfig, dispatchMarketplace = ref3.dispatchMarketplace, setShouldExecuteApi = ref3.setShouldExecuteApi;
    var srcFieldRef = (0,react.useRef)(null);
    var isLoggedIn = Boolean(companyId && isPhoneVerified);
    var marketplaceEventData = (0,react.useMemo)(function() {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventData), {
            source_screen: event_names/* WEB_V2_SOURCE_SCREENS.MARKETPLACE */.ZM.MARKETPLACE
        });
    }, [
        eventData
    ]);
    var trackFieldOnce = (0,homepageV2WebAnalytics/* useTrackWebV2FieldOnce */.YO)(trackEvent, marketplaceEventData).trackFieldOnce;
    var hasActiveFilters = !!(marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : marketplaceConfig.srcStateId) || !!(marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : (ref = marketplaceConfig.destStateIds) === null || ref === void 0 ? void 0 : ref.length) || !!(marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : (ref1 = marketplaceConfig.lorryTypeIds) === null || ref1 === void 0 ? void 0 : ref1.length);
    var onSrcChange = function(value) {
        dispatchMarketplace({
            type: MarketplaceContextProvider/* MARKETPLACE_ACTIONS.APPLY_FILTER */.sF.APPLY_FILTER,
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, marketplaceConfig), {
                srcStateId: value === null || value === void 0 ? void 0 : value.value,
                srcStateIdOption: value
            })
        });
        if (value) {
            (0,trackLoadQuoteFormAnalytics/* trackWebV2LocationField */.$9)(trackFieldOnce, {
                field: "pickup",
                sourceScreen: event_names/* WEB_V2_SOURCE_SCREENS.MARKETPLACE */.ZM.MARKETPLACE,
                location: value.label
            });
        }
    };
    var onDestChange = function(value) {
        dispatchMarketplace({
            type: MarketplaceContextProvider/* MARKETPLACE_ACTIONS.APPLY_FILTER */.sF.APPLY_FILTER,
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, marketplaceConfig), {
                destStateIds: value === null || value === void 0 ? void 0 : value.map(function(state) {
                    return state.value;
                }),
                destStateIdsOption: value || []
            })
        });
        var nextDest = value === null || value === void 0 ? void 0 : value[value.length - 1];
        if (nextDest) {
            (0,trackLoadQuoteFormAnalytics/* trackWebV2LocationField */.$9)(trackFieldOnce, {
                field: "drop",
                sourceScreen: event_names/* WEB_V2_SOURCE_SCREENS.MARKETPLACE */.ZM.MARKETPLACE,
                location: nextDest.label
            });
        }
    };
    var onLorryTypeChange = function(lorryTypeIds) {
        dispatchMarketplace({
            type: MarketplaceContextProvider/* MARKETPLACE_ACTIONS.APPLY_FILTER */.sF.APPLY_FILTER,
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, marketplaceConfig), {
                lorryTypeIds: lorryTypeIds
            })
        });
        var latestId = lorryTypeIds[lorryTypeIds.length - 1];
        if (latestId != null) {
            (0,trackLoadQuoteFormAnalytics/* trackWebV2LorryTypeSelected */.gd)(trackFieldOnce, {
                sourceScreen: event_names/* WEB_V2_SOURCE_SCREENS.MARKETPLACE */.ZM.MARKETPLACE,
                lorryTypeId: latestId,
                dedupeSuffix: latestId
            });
        }
    };
    var onSearch = function() {
        if (!marketplaceConfig.srcStateIdOption) {
            var ref;
            (ref = srcFieldRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            return;
        }
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* GA4EventNames.WEB_V2.market_search_clicked */.wQ.WEB_V2.market_search_clicked, marketplaceEventData);
        if (!isLoggedIn) {
            setShouldPreventLayoutSwitch === null || setShouldPreventLayoutSwitch === void 0 ? void 0 : setShouldPreventLayoutSwitch(true);
            if (!router.asPath.includes("Login")) {
                router.push({
                    hash: "Login"
                }, undefined, {
                    shallow: true
                });
            }
            return;
        }
        updateUrl(marketplaceConfig);
        requestAnimationFrame(function() {
            return (0,methods/* scrollToElementById */.H5)(marketplaceV3_constants/* MARKETPLACE_V3_LOADS_SECTION_ID */.Fz, {
                focus: false
            });
        });
    };
    var onClearFilters = function() {
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* GA4EventNames.MARKET_PLACE.filters_cleared */.wQ.MARKET_PLACE.filters_cleared, marketplaceEventData);
        dispatchMarketplace({
            type: MarketplaceContextProvider/* MARKETPLACE_ACTIONS.CLEAR_FILTER */.sF.CLEAR_FILTER,
            payload: {}
        });
        var baseUrl = routeStrings/* ROUTES.marketplace.getUrl */.Z.marketplace.getUrl(constants/* MarketPlaceType.LOAD */.CY3.LOAD);
        if (router.asPath.split("?")[0] !== baseUrl) {
            router.push(baseUrl, undefined, {
                shallow: true,
                scroll: false
            });
        }
        setShouldExecuteApi(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (MarketplaceV3HeroSection_module_default()).section,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (MarketplaceV3HeroSection_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                    variant: "fade-up",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (MarketplaceV3HeroSection_module_default()).title,
                        children: titleLines.map(function(line) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (MarketplaceV3HeroSection_module_default()).titleLine,
                                children: line
                            }, line);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                    variant: "fade-up",
                    delay: 80,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (MarketplaceV3HeroSection_module_default()).description,
                        children: t("hero.description")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MarketplaceV3HeroSection_module_default()).searchWrap,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(marketplace_v3_MarketplaceLoadFilterCard, {
                        eyebrow: t("search.eyebrow"),
                        fromPlaceholder: t("search.fromPlaceholder"),
                        toPlaceholder: t("search.toPlaceholder"),
                        lorryTypePlaceholder: t("search.lorryTypePlaceholder"),
                        searchLabel: t("search.cta"),
                        clearFiltersLabel: t("search.clearFilters"),
                        hasActiveFilters: hasActiveFilters,
                        srcState: marketplaceConfig.srcStateIdOption,
                        destStates: marketplaceConfig.destStateIdsOption || [],
                        lorryTypeIds: marketplaceConfig.lorryTypeIds || [],
                        srcFieldRef: srcFieldRef,
                        onSrcChange: onSrcChange,
                        onDestChange: onDestChange,
                        onLorryTypeChange: onLorryTypeChange,
                        onSearch: onSearch,
                        onClearFilters: onClearFilters
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var sections_MarketplaceV3HeroSection = (MarketplaceV3HeroSection);

// EXTERNAL MODULE: ../core/dist/icons/ArrowRightGrey.svg
var ArrowRightGrey = __webpack_require__(8526);
// EXTERNAL MODULE: ./components/homepage-v2/section-card/HomepageV2SectionCard.tsx
var HomepageV2SectionCard = __webpack_require__(63968);
// EXTERNAL MODULE: ./components/homepage-v2/available-loads-section/AvailableLoadsGrid.tsx
var AvailableLoadsGrid = __webpack_require__(11452);
// EXTERNAL MODULE: ./components/marketplace/content/content.ts
var content = __webpack_require__(79733);
// EXTERNAL MODULE: ./services/load/useGetLoadMarketV2/useGetLoadMarketInfiniteQueryNew.ts
var useGetLoadMarketInfiniteQueryNew = __webpack_require__(68802);
// EXTERNAL MODULE: ./components/homepage-v2/available-loads-section/AvailableLoadsSectionV2.module.scss
var AvailableLoadsSectionV2_module = __webpack_require__(76045);
var AvailableLoadsSectionV2_module_default = /*#__PURE__*/__webpack_require__.n(AvailableLoadsSectionV2_module);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ./hooks/useValidateUserStatus.ts + 1 modules
var useValidateUserStatus = __webpack_require__(4641);
// EXTERNAL MODULE: ./context/load-lorry-posting.tsx
var load_lorry_posting = __webpack_require__(8574);
// EXTERNAL MODULE: ./components/posting/helpers/constants.ts
var helpers_constants = __webpack_require__(40607);
// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3NoLoadsEmptyState.module.scss
var MarketplaceV3NoLoadsEmptyState_module = __webpack_require__(63643);
var MarketplaceV3NoLoadsEmptyState_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceV3NoLoadsEmptyState_module);
;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3NoLoadsEmptyState.tsx














var MarketplaceV3NoLoadsEmptyState = function(param) {
    var trackEvent = param.trackEvent, eventData = param.eventData;
    var t = (0,useMarketplaceV3Translation/* default */.Z)().t;
    var ValidateLorryPosting = (0,useValidateUserStatus/* default */.Z)().ValidateLorryPosting;
    var loadLorryPostingConfig = (0,load_lorry_posting/* useLoadLorryPosting */.NS)();
    var handlePostLorry = function() {
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* GA4EventNames.MARKET_PLACE.add_lorry_attach_lorry_btn */.wQ.MARKET_PLACE.add_lorry_attach_lorry_btn, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventData), {
            from_screen: "empty_marketplace_v3"
        }));
        ValidateLorryPosting(function() {
            loadLorryPostingConfig === null || loadLorryPostingConfig === void 0 ? void 0 : loadLorryPostingConfig.updateLoadLorryPostingData({
                isModalOpen: true,
                category: "post",
                originationPage: load_lorry_posting/* POSTING_FORM_MODAL_ORIGINATION_PAGE.MARKETPLACE */.ec.MARKETPLACE,
                type: "lorry"
            });
            loadLorryPostingConfig === null || loadLorryPostingConfig === void 0 ? void 0 : loadLorryPostingConfig.openLorryPostingModal(helpers_constants/* LORRY_CREATION_FORM_IDS.VEHICLE_NUMBER */.jU.VEHICLE_NUMBER);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (MarketplaceV3NoLoadsEmptyState_module_default()).emptyState,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                variant: "fade-up",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MarketplaceV3NoLoadsEmptyState_module_default()).illustration,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                        src: marketplaceV3_constants/* MARKETPLACE_V3_ASSETS.noLoadAvailableImage */.jU.noLoadAvailableImage,
                        alt: t("loads.empty.titleLine"),
                        width: 1000,
                        height: 441,
                        unoptimized: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                variant: "fade-up",
                delay: 80,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: (MarketplaceV3NoLoadsEmptyState_module_default()).title,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (MarketplaceV3NoLoadsEmptyState_module_default()).titleLine,
                            children: t("loads.empty.titleLine")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (MarketplaceV3NoLoadsEmptyState_module_default()).titleHighlight,
                            children: t("loads.empty.titleHighlight")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                variant: "fade-up",
                delay: 120,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: (MarketplaceV3NoLoadsEmptyState_module_default()).description,
                    children: [
                        t("loads.empty.descriptionPrefix"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (MarketplaceV3NoLoadsEmptyState_module_default()).descriptionBold,
                            children: t("loads.empty.descriptionBold")
                        }),
                        t("loads.empty.descriptionSuffix")
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                variant: "fade-up",
                delay: 160,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: (MarketplaceV3NoLoadsEmptyState_module_default()).ctaBtn,
                    onClick: handlePostLorry,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("loads.empty.cta")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_white/* default */.Z, {
                            "aria-hidden": true
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var sections_MarketplaceV3NoLoadsEmptyState = (MarketplaceV3NoLoadsEmptyState);

// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3LoadsSection.module.scss
var MarketplaceV3LoadsSection_module = __webpack_require__(52598);
var MarketplaceV3LoadsSection_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceV3LoadsSection_module);
;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3LoadsSection.tsx



















var MarketplaceV3LoadsSection = function(param) {
    var trackEvent = param.trackEvent, eventData = param.eventData, onBidNow = param.onBidNow, inCityTextWithoutIndia = param.inCityTextWithoutIndia;
    var t = (0,useMarketplaceV3Translation/* default */.Z)().t;
    var router = (0,next_router.useRouter)();
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var ref = (0,react.useContext)(MarketplaceContextProvider/* MarketplaceContext */.iT), marketplaceConfig = ref.marketplaceConfig, shouldExecuteApi = ref.shouldExecuteApi, setShouldExecuteApi = ref.setShouldExecuteApi;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), isPhoneVerified = ref1.isPhoneVerified, companyId = ref1.companyId, setShouldPreventLayoutSwitch = ref1.setShouldPreventLayoutSwitch;
    var titleH1Desc = (0,content/* getMktContentByCity */.o)(inCityTextWithoutIndia, true).titleH1Desc;
    var pageSize = isMobileScreen ? marketplaceV3_constants/* MARKETPLACE_V3_LOADS_GRID.mobilePageSize */.f6.mobilePageSize : marketplaceV3_constants/* MARKETPLACE_V3_LOADS_GRID.desktopPageSize */.f6.desktopPageSize;
    var ref2 = (0,react.useState)(0), viewMoreClickCount = ref2[0], setViewMoreClickCount = ref2[1];
    var queryParams = (0,react.useMemo)(function() {
        return {
            preloads: [
                "relevancy_tags"
            ],
            state_id: marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : marketplaceConfig.srcStateId,
            destination_state_id: marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : marketplaceConfig.destStateIds,
            lorry_type_id: marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : marketplaceConfig.lorryTypeIds,
            l: pageSize,
            c_i: Number(companyId) || undefined
        };
    }, [
        pageSize,
        marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : marketplaceConfig.destStateIds,
        marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : marketplaceConfig.lorryTypeIds,
        marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : marketplaceConfig.srcStateId,
        companyId
    ]);
    var filterKey = (0,react.useMemo)(function() {
        var ref, ref1;
        return [
            marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : marketplaceConfig.srcStateId,
            marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : (ref = marketplaceConfig.destStateIds) === null || ref === void 0 ? void 0 : ref.join(","),
            marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : (ref1 = marketplaceConfig.lorryTypeIds) === null || ref1 === void 0 ? void 0 : ref1.join(",")
        ].join("|");
    }, [
        marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : marketplaceConfig.destStateIds,
        marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : marketplaceConfig.lorryTypeIds,
        marketplaceConfig === null || marketplaceConfig === void 0 ? void 0 : marketplaceConfig.srcStateId
    ]);
    (0,react.useEffect)(function() {
        setViewMoreClickCount(0);
    }, [
        filterKey
    ]);
    (0,react.useEffect)(function() {
        requestAnimationFrame(function() {
            return (0,methods/* scrollToElementById */.H5)(marketplaceV3_constants/* MARKETPLACE_V3_LOADS_SECTION_ID */.Fz, {
                focus: false
            });
        });
    }, []);
    var ref3 = (0,useGetLoadMarketInfiniteQueryNew/* useGetLoadMarketInfiniteQueryNew */.Q)(queryParams, {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        retry: 0,
        onSuccess: function onSuccess() {
            setShouldExecuteApi(false);
        },
        onError: function onError() {
            setShouldExecuteApi(false);
        },
        enabled: shouldExecuteApi === true
    }), data = ref3.data, isFetched = ref3.isFetched, isFetching = ref3.isFetching, isFetchingNextPage = ref3.isFetchingNextPage, fetchNextPage = ref3.fetchNextPage, hasNextPage = ref3.hasNextPage;
    var ref4, ref5;
    var loadsData = (0,react.useMemo)(function() {
        var ref;
        return (ref5 = data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap(function(page) {
            var ref;
            return (ref4 = page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.load_cards) !== null && ref4 !== void 0 ? ref4 : [];
        })) !== null && ref5 !== void 0 ? ref5 : [];
    }, [
        data === null || data === void 0 ? void 0 : data.pages
    ]);
    var handleViewMore = function() {
        var isLoggedIn = Boolean(companyId && isPhoneVerified);
        var loginRequired = viewMoreClickCount >= marketplaceV3_constants/* MARKETPLACE_V3_LOADS_GRID.viewMoreClicksBeforeLogin */.f6.viewMoreClicksBeforeLogin && !isLoggedIn;
        if (loginRequired) {
            setShouldPreventLayoutSwitch === null || setShouldPreventLayoutSwitch === void 0 ? void 0 : setShouldPreventLayoutSwitch(true);
            router.push({
                hash: "Login"
            }, undefined, {
                shallow: true
            });
            return;
        }
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* GA4EventNames.WEB_V2.view_more_loads_clicked */.wQ.WEB_V2.view_more_loads_clicked, eventData);
        setViewMoreClickCount(function(count) {
            return count + 1;
        });
        fetchNextPage();
    };
    var isLoadsPending = shouldExecuteApi === undefined || isFetching && !isFetchingNextPage && loadsData.length === 0;
    var showEmptyState = !isLoadsPending && isFetched && loadsData.length === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2SectionCard/* default */.Z, {
        variant: "white",
        id: marketplaceV3_constants/* MARKETPLACE_V3_LOADS_SECTION_ID */.Fz,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (AvailableLoadsSectionV2_module_default()).container,
            children: [
                !showEmptyState ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AvailableLoadsSectionV2_module_default()).header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomepageV2Animate/* default */.Z, {
                        variant: "fade-right",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: (AvailableLoadsSectionV2_module_default()).title,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (AvailableLoadsSectionV2_module_default()).titleLine,
                                        children: t("loads.titleLine")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (AvailableLoadsSectionV2_module_default()).titleHighlight,
                                        children: t("loads.titleHighlight")
                                    })
                                ]
                            }),
                            !isPhoneVerified && titleH1Desc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (MarketplaceV3LoadsSection_module_default()).shortDesc,
                                children: titleH1Desc
                            }) : null
                        ]
                    })
                }) : null,
                showEmptyState ? /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_MarketplaceV3NoLoadsEmptyState, {
                    trackEvent: trackEvent,
                    eventData: eventData
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableLoadsGrid/* default */.Z, {
                            loads: loadsData,
                            cardIdPrefix: "marketplace-v3",
                            onBidNow: onBidNow,
                            showPostingNudge: true,
                            isLoading: isLoadsPending,
                            shimmerCount: pageSize
                        }),
                        hasNextPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                            variant: "fade-up",
                            delay: 180,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (AvailableLoadsSectionV2_module_default()).viewMoreWrap,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: (AvailableLoadsSectionV2_module_default()).viewMoreBtn,
                                    onClick: handleViewMore,
                                    disabled: isFetchingNextPage,
                                    children: [
                                        t("loads.viewMore"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightGrey/* default */.Z, {})
                                    ]
                                })
                            })
                        }) : null
                    ]
                })
            ]
        }, filterKey)
    });
};
/* harmony default export */ var sections_MarketplaceV3LoadsSection = (MarketplaceV3LoadsSection);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ../core/dist/constants/platformStats.js
var platformStats = __webpack_require__(28230);
// EXTERNAL MODULE: ./components/Swipper/Swipper.tsx
var Swipper = __webpack_require__(10169);
// EXTERNAL MODULE: ./components/homepage-v2/web-v2-section-header/WebV2SectionHeader.tsx
var WebV2SectionHeader = __webpack_require__(11250);
// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3BenefitsSection.module.scss
var MarketplaceV3BenefitsSection_module = __webpack_require__(4186);
var MarketplaceV3BenefitsSection_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceV3BenefitsSection_module);
;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3BenefitsSection.tsx














var MarketplaceV3BenefitsSection = function() {
    var t = (0,esm/* useTranslation */.$G)("marketplaceV3").t;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var cardsRaw = t("benefits.cards", (0,_object_spread/* default */.Z)({
        returnObjects: true
    }, (0,platformStats/* getPlatformStatI18nLabels */.E)()));
    var cards = Array.isArray(cardsRaw) ? cardsRaw : [];
    var renderCard = function(card) {
        var isCarousel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: isCarousel ? (MarketplaceV3BenefitsSection_module_default()).cardCarousel : (MarketplaceV3BenefitsSection_module_default()).card,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                    src: marketplaceV3_constants/* MARKETPLACE_V3_ASSETS.benefitCheckIcon */.jU.benefitCheckIcon,
                    alt: "",
                    className: (MarketplaceV3BenefitsSection_module_default()).benefitIcon,
                    width: 36,
                    height: 36,
                    placeholder: "empty",
                    unoptimized: true,
                    "aria-hidden": true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: (MarketplaceV3BenefitsSection_module_default()).cardTitle,
                    children: card.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (MarketplaceV3BenefitsSection_module_default()).cardDescription,
                    children: card.description
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2SectionCard/* default */.Z, {
        variant: "white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (MarketplaceV3BenefitsSection_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                    variant: "fade-up",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebV2SectionHeader/* default */.Z, {
                        title: t("benefits.title"),
                        description: t("benefits.description"),
                        align: "left",
                        className: (MarketplaceV3BenefitsSection_module_default()).sectionHeader,
                        titleClassName: (MarketplaceV3BenefitsSection_module_default()).title,
                        descriptionClassName: (MarketplaceV3BenefitsSection_module_default()).description
                    })
                }),
                isMobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Swipper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: (MarketplaceV3BenefitsSection_module_default()).cardsSwiper
                }, marketplaceV3_constants/* MARKETPLACE_V3_MOBILE_CAROUSEL */.Bj), {
                    list: cards.map(function(card) {
                        return {
                            key: card.title,
                            node: renderCard(card, true)
                        };
                    })
                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MarketplaceV3BenefitsSection_module_default()).grid,
                    children: cards.map(function(card, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                            variant: "fade-up",
                            delay: index * 90,
                            className: (MarketplaceV3BenefitsSection_module_default()).gridItem,
                            children: renderCard(card)
                        }, card.title);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var sections_MarketplaceV3BenefitsSection = (MarketplaceV3BenefitsSection);

// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3WhyChooseSection.module.scss
var MarketplaceV3WhyChooseSection_module = __webpack_require__(59413);
var MarketplaceV3WhyChooseSection_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceV3WhyChooseSection_module);
;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3WhyChooseSection.tsx












var MarketplaceV3WhyChooseSection = function() {
    var t = (0,esm/* useTranslation */.$G)("marketplaceV3").t;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var cardsRaw = t("whyChoose.cards", {
        returnObjects: true
    });
    var cards = Array.isArray(cardsRaw) ? cardsRaw : [];
    var renderCard = function(card) {
        var isCarousel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: isCarousel ? (MarketplaceV3WhyChooseSection_module_default()).dotCardCarousel : (MarketplaceV3WhyChooseSection_module_default()).dotCard,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (MarketplaceV3WhyChooseSection_module_default()).dot,
                    "aria-hidden": true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: (MarketplaceV3WhyChooseSection_module_default()).cardTitle,
                    children: card.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (MarketplaceV3WhyChooseSection_module_default()).cardDescription,
                    children: card.description
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2SectionCard/* default */.Z, {
        variant: "white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (MarketplaceV3WhyChooseSection_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                    variant: "fade-up",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebV2SectionHeader/* default */.Z, {
                        title: t("whyChoose.title"),
                        description: t("whyChoose.description"),
                        align: "left",
                        className: (MarketplaceV3WhyChooseSection_module_default()).sectionHeader,
                        titleClassName: (MarketplaceV3WhyChooseSection_module_default()).title,
                        descriptionClassName: (MarketplaceV3WhyChooseSection_module_default()).description
                    })
                }),
                isMobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Swipper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: (MarketplaceV3WhyChooseSection_module_default()).cardsSwiper
                }, marketplaceV3_constants/* MARKETPLACE_V3_MOBILE_CAROUSEL */.Bj), {
                    list: cards.map(function(card) {
                        return {
                            key: card.title,
                            node: renderCard(card, true)
                        };
                    })
                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MarketplaceV3WhyChooseSection_module_default()).dotGrid,
                    children: cards.map(function(card, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                            variant: "fade-up",
                            delay: index * 90,
                            children: renderCard(card)
                        }, card.title);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var sections_MarketplaceV3WhyChooseSection = (MarketplaceV3WhyChooseSection);

// EXTERNAL MODULE: ./components/homepage-v2/web-v2-faq-section/WebV2FaqSection.tsx
var WebV2FaqSection = __webpack_require__(89729);
// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3FaqSection.module.scss
var MarketplaceV3FaqSection_module = __webpack_require__(48816);
var MarketplaceV3FaqSection_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceV3FaqSection_module);
;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/sections/MarketplaceV3FaqSection.tsx





var MarketplaceV3FaqSection = function(param) {
    var faqItems = param.faqItems;
    var t = (0,esm/* useTranslation */.$G)("marketplaceV3").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WebV2FaqSection/* default */.Z, {
        title: t("faq.title"),
        items: faqItems,
        align: "left",
        containerClassName: (MarketplaceV3FaqSection_module_default()).container,
        titleClassName: (MarketplaceV3FaqSection_module_default()).title
    });
};
/* harmony default export */ var sections_MarketplaceV3FaqSection = (MarketplaceV3FaqSection);

// EXTERNAL MODULE: ./components/homepage-v2/available-loads-section/useCompactLoadBidAction.ts
var useCompactLoadBidAction = __webpack_require__(36940);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core/dist/hooks/useCsDashboard.js
var useCsDashboard = __webpack_require__(68191);
// EXTERNAL MODULE: ../core-ui/dist/hooks/index.js + 3 modules
var hooks = __webpack_require__(95385);
// EXTERNAL MODULE: ./services/load/useGetLoadMarketV2/useGetLoadMarketV2.ts
var useGetLoadMarketV2 = __webpack_require__(32689);
// EXTERNAL MODULE: ./components/homepage-v2/compact-load-bidding/CompactLoadBiddingProvider.tsx
var CompactLoadBiddingProvider = __webpack_require__(64200);
;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/useMarketplaceV3SharedLoadBid.ts











/** Same module-scope latch as MarketPlacePage — open bid once after shared-load fetch. */ var shouldOpenBidFormOnPageLoad = false;
/**
 * Shared `?loadbid=` deep-link flow for marketplace v3 (mirrors MarketPlacePage).
 */ function useMarketplaceV3SharedLoadBid() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), companyId = ref.companyId, customerCompanyId = ref.customerCompanyId, setShouldPreventLayoutSwitch = ref.setShouldPreventLayoutSwitch;
    var dispatchMarketplace = (0,react.useContext)(MarketplaceContextProvider/* MarketplaceContext */.iT).dispatchMarketplace;
    var isCsDashboardUser = (0,useCsDashboard/* useCsDashboard */.Z)().isCsDashboardUser;
    var openCompactBidding = (0,CompactLoadBiddingProvider/* useCompactLoadBidding */.dh)().openCompactBidding;
    var requiredCompanyId = Number(customerCompanyId || companyId) || undefined;
    var isLoadBid = Boolean(router.query["loadbid"]);
    var loadLorryId = router.query["loadbid"] || router.query["lorrybid"];
    var ref1 = (0,react.useState)(), sharedLoad = ref1[0], setSharedLoad = ref1[1];
    var loadNotAvailablePopup = (0,hooks/* useToggleModalWithLocalState */.A$)(false);
    var ref2 = (0,react.useState)(), getSimilarLoad = ref2[0], setGetSimilarLoad = ref2[1];
    (0,useGetLoadMarketV2/* useGetLoadMarketV2New */.a)({
        preloads: [
            "company_detail",
            "bid_infos"
        ],
        isAdmin: isCsDashboardUser,
        loadId: loadLorryId ? [
            Number(loadLorryId)
        ] : undefined,
        c_i: requiredCompanyId
    }, {
        onSuccess: function onSuccess(data) {
            var ref, ref1, ref2;
            shouldOpenBidFormOnPageLoad = true;
            var resultLoad = (ref = data.load_cards) === null || ref === void 0 ? void 0 : ref[0];
            if ((resultLoad === null || resultLoad === void 0 ? void 0 : (ref1 = resultLoad.load_detail) === null || ref1 === void 0 ? void 0 : ref1.status) === constants/* LOAD_STATUS.ACTIVE */.Jtx.ACTIVE) {
                !!resultLoad && setSharedLoad(resultLoad);
            } else if (resultLoad === null || resultLoad === void 0 ? void 0 : (ref2 = resultLoad.load_detail) === null || ref2 === void 0 ? void 0 : ref2.id) {
                setGetSimilarLoad(function() {
                    var ref, ref1;
                    dispatchMarketplace({
                        type: MarketplaceContextProvider/* MARKETPLACE_ACTIONS.APPLY_FILTER */.sF.APPLY_FILTER,
                        payload: {
                            srcStateId: resultLoad.load_detail.source_state_id
                        }
                    });
                    router.push({
                        pathname: (ref1 = (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")) === null || ref1 === void 0 ? void 0 : ref1[0],
                        query: {}
                    }, undefined, {
                        shallow: true
                    });
                });
                loadNotAvailablePopup.openModal();
            }
        },
        onError: function onError() {},
        retry: 0,
        refetchOnWindowFocus: false,
        enabled: isLoadBid && Boolean(loadLorryId)
    });
    (0,react.useEffect)(function() {
        if (!sharedLoad || !shouldOpenBidFormOnPageLoad) {
            return;
        }
        if (sharedLoad.load_detail.company_id != requiredCompanyId) {
            setShouldPreventLayoutSwitch === null || setShouldPreventLayoutSwitch === void 0 ? void 0 : setShouldPreventLayoutSwitch(true);
            openCompactBidding({
                loadData: sharedLoad,
                trackRank: 0
            });
        } else {
            toast/* toast.warning */.A.warning("You can't Bid on this load");
        }
        shouldOpenBidFormOnPageLoad = false;
        var newQuery = (0,_object_spread/* default */.Z)({}, router.query);
        delete newQuery["loadbid"];
        delete newQuery["lorrybid"];
        router.replace({
            pathname: router.pathname,
            query: newQuery
        }, undefined, {
            shallow: true
        });
    // Mirror MarketPlacePage: open once when shared load arrives.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sharedLoad,
        requiredCompanyId,
        loadLorryId
    ]);
    return {
        loadNotAvailablePopup: loadNotAvailablePopup,
        getSimilarLoad: getSimilarLoad
    };
}

// EXTERNAL MODULE: ./components/service-pages/marketplace/marketplace-v3/useMarketplaceV3PageSeo.ts
var useMarketplaceV3PageSeo = __webpack_require__(11144);
// EXTERNAL MODULE: ./components/marketplace-new/marketplace-page-v2/misc/LoadNotAvailablePopup.tsx
var LoadNotAvailablePopup = __webpack_require__(58810);
;// CONCATENATED MODULE: ./components/service-pages/marketplace/marketplace-v3/MarketplaceV3.tsx





























var MarketplaceV3 = function(param) {
    var urlSrc = param.urlSrc, urlDest = param.urlDest, urlFilters = param.urlFilters;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), companyId = ref.companyId, isPhoneVerified = ref.isPhoneVerified;
    var ref1 = (0,react.useContext)(MarketplaceContextProvider/* MarketplaceContext */.iT), marketplaceConfig = ref1.marketplaceConfig, dispatchMarketplace = ref1.dispatchMarketplace, setShouldExecuteApi = ref1.setShouldExecuteApi;
    var ref2 = (0,usePlaceSearchQuery/* usePlaceSearchMutation */.u)(), searchPlaceInfo = ref2.mutateAsync;
    var ref3 = (0,useWebV2Tracker/* useWebV2Tracker */.N)({
        sourceScreen: event_names/* WEB_V2_SOURCE_SCREENS.MARKETPLACE */.ZM.MARKETPLACE,
        pageOpenedEventName: event_names/* GA4EventNames.WEB_V2.marketplace_page_opened */.wQ.WEB_V2.marketplace_page_opened
    }), trackEvent = ref3.trackEvent, eventData = ref3.eventData;
    var initialPhoneVerifiedRef = (0,react.useRef)(isPhoneVerified);
    var hasHydratedFromUrlRef = (0,react.useRef)(false);
    var marketplaceUrlKey = (0,marketplaceV3_constants/* getMarketplaceV3UrlKey */.FE)(router.asPath);
    var updateUrl = function(config) {
        var nextUrl = (0,marketplaceV3_constants/* buildMarketplaceV3SearchUrl */.EO)({
            srcState: config.srcStateIdOption,
            destStates: config.destStateIdsOption,
            lorryTypeIds: config.lorryTypeIds
        });
        // Compare without posting-form params so updateUrl does not wipe an open modal query.
        if (marketplaceUrlKey !== nextUrl) {
            router.push(nextUrl, undefined, {
                shallow: true,
                scroll: false
            });
        }
        setShouldExecuteApi(true);
    };
    (0,react.useEffect)(function() {
        setShouldExecuteApi(undefined);
        hasHydratedFromUrlRef.current = false;
    }, [
        marketplaceUrlKey,
        setShouldExecuteApi
    ]);
    (0,react.useEffect)(function() {
        if (!router.isReady || hasHydratedFromUrlRef.current) {
            return;
        }
        hasHydratedFromUrlRef.current = true;
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, params, locationSegment, parsedFromRouter, resolvedSrc, resolvedDest, ref2, lorryTypeIdsFromRouter, lorryTypeIds, payload, ref3, srcStateIdOption, ref4, destStateIdOption;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        params = router.query.params;
                        locationSegment = Array.isArray(params) ? params[1] : undefined;
                        parsedFromRouter = (0,marketplaceV3_constants/* parseMarketplaceLocationFromParamSegment */.nH)(typeof locationSegment === "string" ? locationSegment : undefined);
                        resolvedSrc = (urlSrc || parsedFromRouter.src).trim();
                        resolvedDest = (urlDest || parsedFromRouter.dest).trim();
                        ;
                        lorryTypeIdsFromRouter = router.query.l ? (ref2 = (ref = (0,marketplacePageHelpers/* getLorryTypeFromParam */.l$)(router.query.l)) === null || ref === void 0 ? void 0 : ref.map(function(lorryType) {
                            return lorryType.id;
                        })) !== null && ref2 !== void 0 ? ref2 : [] : [];
                        lorryTypeIds = (urlFilters === null || urlFilters === void 0 ? void 0 : (ref1 = urlFilters.lorryTypeIds) === null || ref1 === void 0 ? void 0 : ref1.length) ? urlFilters.lorryTypeIds : lorryTypeIdsFromRouter;
                        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, marketplaceConfig), {
                            lorryTypeIds: lorryTypeIds
                        });
                        if (!resolvedSrc) {
                            _ctx.next = 21;
                            break;
                        }
                        ;
                        if (!((ref3 = findMarketplaceStateOptionFromUrlParam(resolvedSrc)) !== null && ref3 !== void 0)) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.t0 = ref3;
                        _ctx.next = 19;
                        break;
                    case 16:
                        _ctx.next = 18;
                        return searchPlaceInfo({
                            query: resolvedSrc,
                            option: {
                                allowState: true,
                                source: city_search_service/* LocationSearchSource.LoadMarketPlaceSearchSource */.T5.LoadMarketPlaceSearchSource
                            }
                        }).then(function(param) {
                            var data = param.data;
                            return MARKETPLACE_STATE_OPTIONS.find(function(state) {
                                var ref;
                                return (0,methods/* compareString */.rR)(state.label, data === null || data === void 0 ? void 0 : (ref = data[0]) === null || ref === void 0 ? void 0 : ref.state);
                            });
                        });
                    case 18:
                        _ctx.t0 = _ctx.sent;
                    case 19:
                        srcStateIdOption = _ctx.t0;
                        if (srcStateIdOption) {
                            payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                                srcStateId: srcStateIdOption.value,
                                srcStateIdOption: srcStateIdOption
                            });
                        }
                    case 21:
                        if (!resolvedDest) {
                            _ctx.next = 32;
                            break;
                        }
                        ;
                        if (!((ref4 = findMarketplaceStateOptionFromUrlParam(resolvedDest)) !== null && ref4 !== void 0)) {
                            _ctx.next = 27;
                            break;
                        }
                        _ctx.t1 = ref4;
                        _ctx.next = 30;
                        break;
                    case 27:
                        _ctx.next = 29;
                        return searchPlaceInfo({
                            query: resolvedDest,
                            option: {
                                allowState: true,
                                source: city_search_service/* LocationSearchSource.LoadMarketPlaceSearchDestination */.T5.LoadMarketPlaceSearchDestination
                            }
                        }).then(function(param) {
                            var data = param.data;
                            return MARKETPLACE_STATE_OPTIONS.find(function(state) {
                                var ref;
                                return (0,methods/* compareString */.rR)(state.label, data === null || data === void 0 ? void 0 : (ref = data[0]) === null || ref === void 0 ? void 0 : ref.state);
                            });
                        });
                    case 29:
                        _ctx.t1 = _ctx.sent;
                    case 30:
                        destStateIdOption = _ctx.t1;
                        if (destStateIdOption) {
                            payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                                destStateIds: [
                                    destStateIdOption.value
                                ],
                                destStateIdsOption: [
                                    destStateIdOption
                                ]
                            });
                        }
                    case 32:
                        dispatchMarketplace({
                            type: MarketplaceContextProvider/* MARKETPLACE_ACTIONS.APPLY_FILTER */.sF.APPLY_FILTER,
                            payload: payload
                        });
                        updateUrl(payload);
                    case 34:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        router.isReady,
        marketplaceUrlKey
    ]);
    (0,react.useEffect)(function() {
        if (isPhoneVerified !== initialPhoneVerifiedRef.current && companyId && isPhoneVerified) {
            updateUrl(marketplaceConfig);
        }
    }, [
        companyId,
        isPhoneVerified
    ]);
    var onClickLoadBid = (0,useCompactLoadBidAction/* useCompactLoadBidAction */._)({
        trackEvent: trackEvent,
        eventData: eventData,
        preBidEventName: event_names/* GA4EventNames.WEB_V2.book_now */.wQ.WEB_V2.book_now
    }).onClickLoadBid;
    var ref4 = useMarketplaceV3SharedLoadBid(), loadNotAvailablePopup = ref4.loadNotAvailablePopup, getSimilarLoad = ref4.getSimilarLoad;
    var ref5 = (0,useMarketplaceV3PageSeo/* useMarketplaceV3PageSeo */.Z)(urlSrc, urlDest), asPath = ref5.asPath, breadcrumbItems = ref5.breadcrumbItems, faqList = ref5.faqList, inCityTextWithoutIndia = ref5.inCityTextWithoutIndia, marketplaceSeoPath = ref5.marketplaceSeoPath, pageMeta = ref5.pageMeta, shouldBeIndexed = ref5.shouldBeIndexed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaTags/* default */.Z, {
                asPath: asPath,
                localeNeutralPath: marketplaceSeoPath,
                title: pageMeta.title,
                description: pageMeta.description,
                keywords: pageMeta.keywords,
                ogImgAltText: pageMeta.ogImgAltText,
                schema: {
                    breadcrumbItems: breadcrumbItems,
                    faqList: faqList
                },
                shouldBeIndexed: shouldBeIndexed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: (MarketplaceV3_module_default()).main,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_MarketplaceV3HeroSection, {
                        trackEvent: trackEvent,
                        eventData: eventData,
                        updateUrl: updateUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MarketplaceV3_module_default()).contentStack,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_MarketplaceV3LoadsSection, {
                                trackEvent: trackEvent,
                                eventData: eventData,
                                onBidNow: onClickLoadBid,
                                inCityTextWithoutIndia: inCityTextWithoutIndia
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_MarketplaceV3BenefitsSection, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_MarketplaceV3WhyChooseSection, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_MarketplaceV3FaqSection, {
                                faqItems: faqList
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDownloadBannerV2/* default */.Z, {
                                trackEvent: trackEvent,
                                eventData: eventData
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadNotAvailablePopup/* default */.Z, {
                isOpen: loadNotAvailablePopup.isModalOpen,
                onSubmit: function() {
                    loadNotAvailablePopup.toggleModal();
                    getSimilarLoad === null || getSimilarLoad === void 0 ? void 0 : getSimilarLoad();
                },
                onToggle: loadNotAvailablePopup.toggleModal
            })
        ]
    });
};
/* harmony default export */ var marketplace_v3_MarketplaceV3 = (MarketplaceV3);

// EXTERNAL MODULE: ./components/city/CityLandingPage.tsx
var CityLandingPage = __webpack_require__(61887);
;// CONCATENATED MODULE: ./pages/marketplace/[...params].tsx






var MarketplacePage = function(props) {
    if (props.marketplaceType === constants/* MarketPlaceType.LORRY */.CY3.LORRY) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CityLandingPage/* default */.Z, {
            marketplaceLorry: {
                urlSrc: props.urlSrc,
                urlDest: props.urlDest
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(marketplace_v3_MarketplaceV3, (0,_object_spread/* default */.Z)({}, props));
};
var __N_SSG = true;
/* harmony default export */ var _params_ = (MarketplacePage);


/***/ }),

/***/ 10599:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"WebV2FaqSection_container__D0Sy8","sectionHeader":"WebV2FaqSection_sectionHeader__eFW9J","sectionTitle":"WebV2FaqSection_sectionTitle__SEkUZ","list":"WebV2FaqSection_list__yn7iH","item":"WebV2FaqSection_item__Q9zJp","itemOpen":"WebV2FaqSection_itemOpen__fUmRf","questionBtn":"WebV2FaqSection_questionBtn__1QBOd","chevron":"WebV2FaqSection_chevron__WMy4Z","chevronOpen":"WebV2FaqSection_chevronOpen__suLCq","answerWrap":"WebV2FaqSection_answerWrap__aYkcX","answerWrapOpen":"WebV2FaqSection_answerWrapOpen__1UHq9","answerInner":"WebV2FaqSection_answerInner__EJrOb","answer":"WebV2FaqSection_answer__nJOPJ","hpv2HeroSlideIn":"WebV2FaqSection_hpv2HeroSlideIn__1kY1D","hpv2HeroFadeIn":"WebV2FaqSection_hpv2HeroFadeIn__blLJR","hpv2HeroFadeInOpacity":"WebV2FaqSection_hpv2HeroFadeInOpacity__hWQw6","hpv2FadeUp":"WebV2FaqSection_hpv2FadeUp__U__EK","hpv2FadeLeft":"WebV2FaqSection_hpv2FadeLeft__sBubB","hpv2FadeRight":"WebV2FaqSection_hpv2FadeRight__gQTjg","hpv2ScaleUp":"WebV2FaqSection_hpv2ScaleUp__VEwB1","hpv2Blink":"WebV2FaqSection_hpv2Blink__NnMA8","hpv2FloatA":"WebV2FaqSection_hpv2FloatA__hjfc_","hpv2FloatB":"WebV2FaqSection_hpv2FloatB__aeInM","hpv2DemoProgress":"WebV2FaqSection_hpv2DemoProgress__6GQXn","hpv2DemoSlideIn":"WebV2FaqSection_hpv2DemoSlideIn__RVDgU","hpv2DemoFadeIn":"WebV2FaqSection_hpv2DemoFadeIn__xT2DW","hpv2DemoScaleIn":"WebV2FaqSection_hpv2DemoScaleIn__xoh8X","hpv2DemoBounce":"WebV2FaqSection_hpv2DemoBounce__aDOQa","hpv2PulseDot":"WebV2FaqSection_hpv2PulseDot__QXANb","hpv2PriceShimmer":"WebV2FaqSection_hpv2PriceShimmer__ItHPC"};

/***/ }),

/***/ 68177:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"WebV2SectionHeader_header__PMFGg","center":"WebV2SectionHeader_center__54ylg","left":"WebV2SectionHeader_left__Wlplv","eyebrow":"WebV2SectionHeader_eyebrow__yjBnu","title":"WebV2SectionHeader_title__mm7Ug","description":"WebV2SectionHeader_description___X7qM"};

/***/ }),

/***/ 15841:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"MarketplaceLoadFilterCard_card__eCTZH","fieldWrap":"MarketplaceLoadFilterCard_fieldWrap__pUf3_","fieldWrapSelect":"MarketplaceLoadFilterCard_fieldWrapSelect__uTig8","fieldWrapMulti":"MarketplaceLoadFilterCard_fieldWrapMulti__G44EB","multiFieldValue":"MarketplaceLoadFilterCard_multiFieldValue__3aAaq","fieldWrapSearchable":"MarketplaceLoadFilterCard_fieldWrapSearchable__fcZxF","locationSelectControl":"MarketplaceLoadFilterCard_locationSelectControl__jR3zP","fieldIconWrap":"MarketplaceLoadFilterCard_fieldIconWrap__zZoyZ","fieldPlaceholder":"MarketplaceLoadFilterCard_fieldPlaceholder__BthWR","fieldValue":"MarketplaceLoadFilterCard_fieldValue__TkT3G","selectChevronWrap":"MarketplaceLoadFilterCard_selectChevronWrap__7P5p7","fieldIcon":"MarketplaceLoadFilterCard_fieldIcon__0Cti3","fieldIconPin":"MarketplaceLoadFilterCard_fieldIconPin__sdh3C","chevronIcon":"MarketplaceLoadFilterCard_chevronIcon___KXnh","chevronIconOpen":"MarketplaceLoadFilterCard_chevronIconOpen__xEy8C","lorrySelectControl":"MarketplaceLoadFilterCard_lorrySelectControl__4B0QS","lorrySelectControlOpen":"MarketplaceLoadFilterCard_lorrySelectControlOpen__abUcb","checkboxOptionRow":"MarketplaceLoadFilterCard_checkboxOptionRow__uzVKb","lorryDropdownMenu":"MarketplaceLoadFilterCard_lorryDropdownMenu__a5ZtJ","lorryOption":"MarketplaceLoadFilterCard_lorryOption__HfS9l","lorryOptionActive":"MarketplaceLoadFilterCard_lorryOptionActive__Y9Q6t","lorryOptionSelected":"MarketplaceLoadFilterCard_lorryOptionSelected__gW_aS","eyebrow":"MarketplaceLoadFilterCard_eyebrow__DY2sW","filtersRow":"MarketplaceLoadFilterCard_filtersRow___Bx1Q","row":"MarketplaceLoadFilterCard_row__ixWVY","rowLocations":"MarketplaceLoadFilterCard_rowLocations__Cej_d","routeGroup":"MarketplaceLoadFilterCard_routeGroup__3xIjJ","lorryField":"MarketplaceLoadFilterCard_lorryField__XSwYe","searchBtn":"MarketplaceLoadFilterCard_searchBtn__hmIWx","searchBtnIcon":"MarketplaceLoadFilterCard_searchBtnIcon__KaDP8","actionsRow":"MarketplaceLoadFilterCard_actionsRow__YxaX7","clearBtn":"MarketplaceLoadFilterCard_clearBtn__cPZAE","hpv2HeroSlideIn":"MarketplaceLoadFilterCard_hpv2HeroSlideIn__CYloI","hpv2HeroFadeIn":"MarketplaceLoadFilterCard_hpv2HeroFadeIn__Mu75F","hpv2HeroFadeInOpacity":"MarketplaceLoadFilterCard_hpv2HeroFadeInOpacity__Ca5G9","hpv2FadeUp":"MarketplaceLoadFilterCard_hpv2FadeUp__qYKP6","hpv2FadeLeft":"MarketplaceLoadFilterCard_hpv2FadeLeft__OrvWI","hpv2FadeRight":"MarketplaceLoadFilterCard_hpv2FadeRight__ZApGu","hpv2ScaleUp":"MarketplaceLoadFilterCard_hpv2ScaleUp__XCHO7","hpv2Blink":"MarketplaceLoadFilterCard_hpv2Blink__uXP0m","hpv2FloatA":"MarketplaceLoadFilterCard_hpv2FloatA__0DhNy","hpv2FloatB":"MarketplaceLoadFilterCard_hpv2FloatB__sHfWj","hpv2DemoProgress":"MarketplaceLoadFilterCard_hpv2DemoProgress__N5_sk","hpv2DemoSlideIn":"MarketplaceLoadFilterCard_hpv2DemoSlideIn__5S8kh","hpv2DemoFadeIn":"MarketplaceLoadFilterCard_hpv2DemoFadeIn__qE3jj","hpv2DemoScaleIn":"MarketplaceLoadFilterCard_hpv2DemoScaleIn__g7om6","hpv2DemoBounce":"MarketplaceLoadFilterCard_hpv2DemoBounce__jh9d7","hpv2PulseDot":"MarketplaceLoadFilterCard_hpv2PulseDot__jTiIQ","hpv2PriceShimmer":"MarketplaceLoadFilterCard_hpv2PriceShimmer__4Uq_9"};

/***/ }),

/***/ 83915:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"MarketplaceV3_main__li5Sw","contentStack":"MarketplaceV3_contentStack__3OJrn","hpv2HeroSlideIn":"MarketplaceV3_hpv2HeroSlideIn__Nn_5i","hpv2HeroFadeIn":"MarketplaceV3_hpv2HeroFadeIn__EjcXY","hpv2HeroFadeInOpacity":"MarketplaceV3_hpv2HeroFadeInOpacity__B9aOY","hpv2FadeUp":"MarketplaceV3_hpv2FadeUp__SWl8M","hpv2FadeLeft":"MarketplaceV3_hpv2FadeLeft__snrFA","hpv2FadeRight":"MarketplaceV3_hpv2FadeRight__9d0lk","hpv2ScaleUp":"MarketplaceV3_hpv2ScaleUp__f0xXn","hpv2Blink":"MarketplaceV3_hpv2Blink__osazd","hpv2FloatA":"MarketplaceV3_hpv2FloatA__9NO_6","hpv2FloatB":"MarketplaceV3_hpv2FloatB__dslN4","hpv2DemoProgress":"MarketplaceV3_hpv2DemoProgress__VPvAY","hpv2DemoSlideIn":"MarketplaceV3_hpv2DemoSlideIn__38jrx","hpv2DemoFadeIn":"MarketplaceV3_hpv2DemoFadeIn__SsHqU","hpv2DemoScaleIn":"MarketplaceV3_hpv2DemoScaleIn__CkWgW","hpv2DemoBounce":"MarketplaceV3_hpv2DemoBounce__59tSD","hpv2PulseDot":"MarketplaceV3_hpv2PulseDot__xkztA","hpv2PriceShimmer":"MarketplaceV3_hpv2PriceShimmer__bG1hF"};

/***/ }),

/***/ 40601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sheet":"MarketplaceFilterMobileSheet_sheet__YPNBL","rowButton":"MarketplaceFilterMobileSheet_rowButton__QKHf7","checkboxRow":"MarketplaceFilterMobileSheet_checkboxRow__7QqIu","checkboxLabel":"MarketplaceFilterMobileSheet_checkboxLabel__dcwsg","radioRow":"MarketplaceFilterMobileSheet_radioRow__b350q"};

/***/ }),

/***/ 4186:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketplaceV3BenefitsSection_container___r7zb","sectionHeader":"MarketplaceV3BenefitsSection_sectionHeader__yqTYj","title":"MarketplaceV3BenefitsSection_title__w6NyP","description":"MarketplaceV3BenefitsSection_description__8H_cG","grid":"MarketplaceV3BenefitsSection_grid__QIixc","gridItem":"MarketplaceV3BenefitsSection_gridItem__0eB7o","card":"MarketplaceV3BenefitsSection_card__vSLoM","cardCarousel":"MarketplaceV3BenefitsSection_cardCarousel__PITr0","benefitIcon":"MarketplaceV3BenefitsSection_benefitIcon__V3WOV","cardTitle":"MarketplaceV3BenefitsSection_cardTitle__7UMqA","cardDescription":"MarketplaceV3BenefitsSection_cardDescription__ZqWAD","cardsSwiper":"MarketplaceV3BenefitsSection_cardsSwiper__i1YOn","hpv2HeroSlideIn":"MarketplaceV3BenefitsSection_hpv2HeroSlideIn__ETMZu","hpv2HeroFadeIn":"MarketplaceV3BenefitsSection_hpv2HeroFadeIn__zwtv0","hpv2HeroFadeInOpacity":"MarketplaceV3BenefitsSection_hpv2HeroFadeInOpacity__NBcdZ","hpv2FadeUp":"MarketplaceV3BenefitsSection_hpv2FadeUp__0gdIv","hpv2FadeLeft":"MarketplaceV3BenefitsSection_hpv2FadeLeft__rOKvk","hpv2FadeRight":"MarketplaceV3BenefitsSection_hpv2FadeRight__mSM9f","hpv2ScaleUp":"MarketplaceV3BenefitsSection_hpv2ScaleUp__mozXb","hpv2Blink":"MarketplaceV3BenefitsSection_hpv2Blink__pEUc1","hpv2FloatA":"MarketplaceV3BenefitsSection_hpv2FloatA__MNcXi","hpv2FloatB":"MarketplaceV3BenefitsSection_hpv2FloatB__kmIi0","hpv2DemoProgress":"MarketplaceV3BenefitsSection_hpv2DemoProgress__HacZi","hpv2DemoSlideIn":"MarketplaceV3BenefitsSection_hpv2DemoSlideIn__PtABo","hpv2DemoFadeIn":"MarketplaceV3BenefitsSection_hpv2DemoFadeIn__KHTLU","hpv2DemoScaleIn":"MarketplaceV3BenefitsSection_hpv2DemoScaleIn__t_cfq","hpv2DemoBounce":"MarketplaceV3BenefitsSection_hpv2DemoBounce__Kc9G6","hpv2PulseDot":"MarketplaceV3BenefitsSection_hpv2PulseDot__AZ5kc","hpv2PriceShimmer":"MarketplaceV3BenefitsSection_hpv2PriceShimmer__yVm2M"};

/***/ }),

/***/ 48816:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketplaceV3FaqSection_container__fAsPI","title":"MarketplaceV3FaqSection_title__fhyoV"};

/***/ }),

/***/ 97776:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"MarketplaceV3HeroSection_section__HjBgt","container":"MarketplaceV3HeroSection_container__KtGTD","title":"MarketplaceV3HeroSection_title__ham9g","titleLine":"MarketplaceV3HeroSection_titleLine__XT_3I","description":"MarketplaceV3HeroSection_description__UkafO","searchWrap":"MarketplaceV3HeroSection_searchWrap__6JW4w","hpv2HeroSlideIn":"MarketplaceV3HeroSection_hpv2HeroSlideIn__Mr6nN","hpv2HeroFadeIn":"MarketplaceV3HeroSection_hpv2HeroFadeIn__3clyY","hpv2HeroFadeInOpacity":"MarketplaceV3HeroSection_hpv2HeroFadeInOpacity__vG5yB","hpv2FadeUp":"MarketplaceV3HeroSection_hpv2FadeUp__MZ4lU","hpv2FadeLeft":"MarketplaceV3HeroSection_hpv2FadeLeft__5ZS8y","hpv2FadeRight":"MarketplaceV3HeroSection_hpv2FadeRight__Uf5nB","hpv2ScaleUp":"MarketplaceV3HeroSection_hpv2ScaleUp__R8yyO","hpv2Blink":"MarketplaceV3HeroSection_hpv2Blink__xrR3n","hpv2FloatA":"MarketplaceV3HeroSection_hpv2FloatA__MsKuU","hpv2FloatB":"MarketplaceV3HeroSection_hpv2FloatB__DoBJj","hpv2DemoProgress":"MarketplaceV3HeroSection_hpv2DemoProgress__IEonM","hpv2DemoSlideIn":"MarketplaceV3HeroSection_hpv2DemoSlideIn__Gh5_R","hpv2DemoFadeIn":"MarketplaceV3HeroSection_hpv2DemoFadeIn__jAbsX","hpv2DemoScaleIn":"MarketplaceV3HeroSection_hpv2DemoScaleIn__HtNSk","hpv2DemoBounce":"MarketplaceV3HeroSection_hpv2DemoBounce__OGNLZ","hpv2PulseDot":"MarketplaceV3HeroSection_hpv2PulseDot__f1RNx","hpv2PriceShimmer":"MarketplaceV3HeroSection_hpv2PriceShimmer__e3AUN"};

/***/ }),

/***/ 52598:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shortDesc":"MarketplaceV3LoadsSection_shortDesc__1y7nr"};

/***/ }),

/***/ 63643:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"MarketplaceV3NoLoadsEmptyState_emptyState__LW_N7","illustration":"MarketplaceV3NoLoadsEmptyState_illustration__tZpZ3","title":"MarketplaceV3NoLoadsEmptyState_title__R_hWZ","titleLine":"MarketplaceV3NoLoadsEmptyState_titleLine__vyzec","titleHighlight":"MarketplaceV3NoLoadsEmptyState_titleHighlight__wySkl","description":"MarketplaceV3NoLoadsEmptyState_description__6d8Mz","descriptionBold":"MarketplaceV3NoLoadsEmptyState_descriptionBold__g45Gj","ctaBtn":"MarketplaceV3NoLoadsEmptyState_ctaBtn__1a0Zk","hpv2HeroSlideIn":"MarketplaceV3NoLoadsEmptyState_hpv2HeroSlideIn__SJNag","hpv2HeroFadeIn":"MarketplaceV3NoLoadsEmptyState_hpv2HeroFadeIn__evWvS","hpv2HeroFadeInOpacity":"MarketplaceV3NoLoadsEmptyState_hpv2HeroFadeInOpacity__UyAJ9","hpv2FadeUp":"MarketplaceV3NoLoadsEmptyState_hpv2FadeUp__bdyOZ","hpv2FadeLeft":"MarketplaceV3NoLoadsEmptyState_hpv2FadeLeft__vCREL","hpv2FadeRight":"MarketplaceV3NoLoadsEmptyState_hpv2FadeRight__xTBVG","hpv2ScaleUp":"MarketplaceV3NoLoadsEmptyState_hpv2ScaleUp__y2f7_","hpv2Blink":"MarketplaceV3NoLoadsEmptyState_hpv2Blink__Gb5Wq","hpv2FloatA":"MarketplaceV3NoLoadsEmptyState_hpv2FloatA__sP3MR","hpv2FloatB":"MarketplaceV3NoLoadsEmptyState_hpv2FloatB__53zP0","hpv2DemoProgress":"MarketplaceV3NoLoadsEmptyState_hpv2DemoProgress__t_Un4","hpv2DemoSlideIn":"MarketplaceV3NoLoadsEmptyState_hpv2DemoSlideIn__aW4ok","hpv2DemoFadeIn":"MarketplaceV3NoLoadsEmptyState_hpv2DemoFadeIn__XlYEW","hpv2DemoScaleIn":"MarketplaceV3NoLoadsEmptyState_hpv2DemoScaleIn__ublw6","hpv2DemoBounce":"MarketplaceV3NoLoadsEmptyState_hpv2DemoBounce__j_gfg","hpv2PulseDot":"MarketplaceV3NoLoadsEmptyState_hpv2PulseDot__T0vzs","hpv2PriceShimmer":"MarketplaceV3NoLoadsEmptyState_hpv2PriceShimmer__Vk60g"};

/***/ }),

/***/ 59413:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketplaceV3WhyChooseSection_container__5zWTs","sectionHeader":"MarketplaceV3WhyChooseSection_sectionHeader__RwHn7","title":"MarketplaceV3WhyChooseSection_title__rdXc3","description":"MarketplaceV3WhyChooseSection_description___1svX","dotGrid":"MarketplaceV3WhyChooseSection_dotGrid__uWjEM","dotCard":"MarketplaceV3WhyChooseSection_dotCard__v7CV8","dotCardCarousel":"MarketplaceV3WhyChooseSection_dotCardCarousel__5Y8K5","dot":"MarketplaceV3WhyChooseSection_dot__Fo_fV","cardTitle":"MarketplaceV3WhyChooseSection_cardTitle__UpMQr","cardDescription":"MarketplaceV3WhyChooseSection_cardDescription__6eeUg","cardsSwiper":"MarketplaceV3WhyChooseSection_cardsSwiper__XSa2E","hpv2HeroSlideIn":"MarketplaceV3WhyChooseSection_hpv2HeroSlideIn__36nPc","hpv2HeroFadeIn":"MarketplaceV3WhyChooseSection_hpv2HeroFadeIn__O35_i","hpv2HeroFadeInOpacity":"MarketplaceV3WhyChooseSection_hpv2HeroFadeInOpacity__xFKMv","hpv2FadeUp":"MarketplaceV3WhyChooseSection_hpv2FadeUp__soQFs","hpv2FadeLeft":"MarketplaceV3WhyChooseSection_hpv2FadeLeft__baqN5","hpv2FadeRight":"MarketplaceV3WhyChooseSection_hpv2FadeRight__5sPQk","hpv2ScaleUp":"MarketplaceV3WhyChooseSection_hpv2ScaleUp__ms04b","hpv2Blink":"MarketplaceV3WhyChooseSection_hpv2Blink__edOkS","hpv2FloatA":"MarketplaceV3WhyChooseSection_hpv2FloatA__8wpkU","hpv2FloatB":"MarketplaceV3WhyChooseSection_hpv2FloatB__Ov8fa","hpv2DemoProgress":"MarketplaceV3WhyChooseSection_hpv2DemoProgress__sAofa","hpv2DemoSlideIn":"MarketplaceV3WhyChooseSection_hpv2DemoSlideIn__tFWhH","hpv2DemoFadeIn":"MarketplaceV3WhyChooseSection_hpv2DemoFadeIn__Kok9_","hpv2DemoScaleIn":"MarketplaceV3WhyChooseSection_hpv2DemoScaleIn__4oBr_","hpv2DemoBounce":"MarketplaceV3WhyChooseSection_hpv2DemoBounce__B1gIN","hpv2PulseDot":"MarketplaceV3WhyChooseSection_hpv2PulseDot__Lsx4L","hpv2PriceShimmer":"MarketplaceV3WhyChooseSection_hpv2PriceShimmer__QiUHF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5502,4800,5829,1217,3128,4732,2765,8416,5326,8116,5755,1887,9616,9774,2888,179], function() { return __webpack_exec__(68732); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);